import { Box, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography, Autocomplete, Chip, InputAdornment, Checkbox, FormControlLabel, FormHelperText, MenuItem, AccordionDetails, FormControl, Select, InputLabel } from '@mui/material'
import TriggerApiOnView from './TriggerApiOnView'
import React, { useEffect, useState, useMemo } from 'react'
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import { ADD, AnteriorImage, AXIS_OPTIONS, BASE_OPTION, BCDVA_OPTIONS, BCNVA, COMMON_STYLE, CYL_OPTIONS, DEFAULT_CHARTUSED_SR, DEFAULT_MUSCLES_SR, DEFAULT_OCCUPATIONS_SR, FundusImage, LENS_COATING_OPTIONS, LENS_TYPE_OPTIONS, NEW_DOC_NOTES_FOR_COLLAB_SUMMARY, NV_OPTIONS, OTHER_INVESTIGATION_CONFIG_DATA, oxygen_source_list, PRISM_OPTIONS, SPH_OPTIONS, UCVA_OPTIONS, UMA_IOL_MASTER_LIST, UMA_LENS_ENHANCEMENT, UMA_LENS_MATERIAL, UMA_LENS_TYPE, UMA_RECOMMENDED_EYE_WEAR } from '../../../../Utility/Constants'
import { Colors } from '../../../../Styles/Colors'
import DescriptionIcon from '@mui/icons-material/Description'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Button } from 'antd'
import { render } from '@testing-library/react'


const deepCopyFunc = (arr) => {
    return JSON.parse(JSON.stringify(arr))
}

const commonArr = [
    { "eye_type": "RE", "SPH": "", "CYL": "", "AXIS": "", "BCDVA": "" },
    { "eye_type": "LE", "SPH": "", "CYL": "", "AXIS": "", "BCDVA": "" },
]

const headers = ['Eye', 'SPH', 'CYL', 'AXIS', 'BCDVA'];

const eyeHeaders = ['Eye', "BEVN"]

const refracArr = [
    { "eye_type": "RE", "UCVA": "", "SPH": "", "CYL": "", "AXIS": "", "target": "", "BCDVA": "" },
    { "eye_type": "LE", "UCVA": "", "SPH": "", "CYL": "", "AXIS": "", "target": "", "BCDVA": "" },
]

const eyeObj = { "distance": "", "near": "" }

const doctorNote = {
    pgp: {},
    subjective_refraction: {},
    retinoscopic_refraction: {
        retinoComments: '',
        beforeDilation: [],
        afterDilation: [],
    },
    retinoscopic_acceptance: {},
    vision_assesment: {
        chart: "",
        occupation: "",
        comment: "",
    },
    ocular_response_analyzer: {},
    intraocular_pressure: {},
    auto_refractory: {
        Comments: '',
    },
    anterior_segment: {
        LidsRightEye: null,
        ConjunctivaRightEye: null,
        ScleraRightEye: null,
        CorneaRightEye: null,
        AnteriorChambRightEye: null,
        PupilRightEye: null,
        IrisRightEye: null,
        LensRightEye: null,
        LidsLeftEye: null,
        ConjunctivaLeftEye: null,
        ScleraLeftEye: null,
        CorneaLeftEye: null,
        AnteriorChambLeftEye: null,
        PupilLeftEye: null,
        IrisLeftEye: null,
        LensLeftEye: null,
        ExtraocularRightEye: null,
        ExtraocularLeftEye: null,
        rightEye: false,
        lefytEye: false,
    },
    posterior_segment: {
        rightEye: false,
        lefytEye: false,
        normal: false,

        discRightEye: "",
        maculaRightEye: "",
        mediaRightEye: "",
        vesselsRightEye: "",
        peripheryRightEye: "",

        discLeftEye: "",
        maculaLeftEye: "",
        mediaLeftEye: "",
        vesselsLeftEye: "",
        peripheryLeftEye: "",
    },
    anterior_segment_diagram: AnteriorImage,
    fundus: FundusImage,
    keratomentry: {},
    IOLMaster: [],
    other_investigation: {

        rightEye: false,
        leftEye: false,
        normal: false,

        WFDTRightEye: "",
        EOMRightEye: "",
        ColorVisionRightEye: "",
        ConfrontationRightEye: "",
        PupilRightEye: "",
        PachymentryRightEye: "",
        SchirmerRightEye: "",
        ContrastRightEye: "",
        SyringeRightEye: "",
        AdditionalRightEye: "",
        DuctRightEye: "",

        WFDTLeftEye: "",
        EOMLeftEye: "",
        ColorVisionLeftEye: "",
        ConfrontationLeftEye: "",
        PupilLeftEye: "",
        PachymentryLeftEye: "",
        SchirmerLeftEye: "",
        ContrastLeftEye: "",
        SyringeLeftEye: "",
        AdditionalLeftEye: "",
        DuctLeftEye: "",

        WFDTSuggRE: [],
        WFDTSuggLE: [],
        EOMSuggRE: [],
        EOMSuggLE: [],
        ColorVisionSuggRE: [],
        ColorVisionSuggLE: [],
        ConfrontationSuggRE: [],
        ConfrontationSuggLE: [],
        PupilSuggRE: [],
        PupilSuggLE: [],
        PachymentrySuggRE: [],
        PachymentrySuggLE: [],
        SchirmerSuggRE: [],
        SchirmerSuggLE: [],
        ContrastSuggRE: [],
        ContrastSuggLE: [],
        SyringeRE: [],
        SyringeLE: [],
        AdditionalLE: [],
        AdditionalRE: [],
        DuctLE: [],
        DuctRE: [],
        addCustomBox: []
    },
    gonioscopy: {
        B_R_Inferior: "",
        B_R_Nasal: "",
        B_R_Superior: "",
        B_R_Temporal: "",
        B_L_Inferior: "",
        B_L_Nasal: "",
        B_L_Superior: "",
        B_L_Temporal: "",
        A_R_Inferior: "",
        A_R_Nasal: "",
        A_R_Superior: "",
        A_R_Temporal: "",
        A_L_Inferior: "",
        A_L_Nasal: "",
        A_L_Superior: "",
        A_L_Temporal: "",
        itemList: [],
        itemListAfter: [],
        PreitemList: [],
        PreitemListAfter: [],
        RE_Inferior: "",
        RE_Nasal: "",
        RE_Superior: "",
        RE_Temporal: "",
        LE_Inferior: "",
        LE_Nasal: "",
        LE_Superior: "",
        LE_Temporal: "",
    },
    treatment_plan: "",
    diagonis: {
        diagonisData: [],
        diagonisDataList: [],
        provisional_diagnosis: '',
    },
    notes: '',
    optometry_notes: '',
    oct_findings: '',
    prescription: {
        taperAddedDetails: [],
        prescription_lines: [],
        tapper_meds: [],
    },
    Patient_Category: {
        patientCategoryData: [],
    },
    complaints: {
        complainDescrp: '',
    },
    ocular_history: {
        MedicationData: [],
        SurgeryData: [],
        ContactLensData: [],
        OthersData: [],
    },
    systemic_illness: {
        IllnessData: [],
        AllergyData: [],
    },
    review_plan: {
        ReviewData: [],
    },
    investigations: {
        Testdata: [],
    },
    schirmer_test: {},
    vitals: {
        height: '',
        weight: '',
        bp_d: '',
        bp_s: '',
        temp: '',
        spo2: '',
        pulserate: '',
        bloodglucouse: '',
        postLoading: false,
        tempUnit: 'F',
        vitalsData: [],
        loading: false,
        isLocked: false,
        bmi: 0.00,
        bsa: 0.00,
        headCircumference: '',
        waist_circumference: '',
        show_waist_circumference: false,
        filteredRightField_data: [],
    },
    glass_prescription: {
        Leftchecked: false,
        Rightchecked: false,
        postLoad: false,
        templateDataLeft: [],
        templateDataRight: [],
        Occupation: "",
        Chart: "",
        Muscle: "",
        PreviousData: [],
        LensType: [],
        LensCoat: [],
        coatingCom: "",
        wearingIns: "",

        //UMA
        glassprespData: [],
        selectedLensType: [],
        glassPrespComments: '',
        selectedEyeWear: '',
        selectedLensMaterial: '',
        selectedLensEnhacement: '',
        sameGlass: false,
        selectedLens: '',
        lensTypeList: UMA_LENS_TYPE,
        eyeWearList: UMA_RECOMMENDED_EYE_WEAR,
        lensMaterialList: UMA_LENS_MATERIAL,
        lensEnhancementList: UMA_LENS_ENHANCEMENT,

    },
    umaGlassPrescription: {
        SPHList: SPH_OPTIONS,
        CYLList: CYL_OPTIONS,
        NVLIST: NV_OPTIONS,
        AXISList: AXIS_OPTIONS,
        ADDList: ADD,
        BCDVAList: BCDVA_OPTIONS,
        BCNVAList: BCNVA,
        PRISMList: PRISM_OPTIONS,
        BASEList: BASE_OPTION,
    },
    smile: {
        SPHList: SPH_OPTIONS,
        CYLList: CYL_OPTIONS,
        AXISList: AXIS_OPTIONS,
        BCDVAList: BCDVA_OPTIONS,
        smileComments: '',
        prevSmileComments: '',
        underRefractionData: deepCopyFunc(commonArr),
        prevUnderRefractionData: [],
        acceptanceData: deepCopyFunc(commonArr),
        prevAcceptanceData: [],
        overRefractionData: deepCopyFunc(commonArr),
    },
    presbyond: {
        SPHList: SPH_OPTIONS,
        CYLList: CYL_OPTIONS,
        AXISList: AXIS_OPTIONS,
        BCDVAList: BCDVA_OPTIONS,
        BCNVAList: BCNVA,
        UCVAList: UCVA_OPTIONS,
        dominantEye: "",
        comments: "",
        refractionData: deepCopyFunc(refracArr),
        eyeData: deepCopyFunc(eyeObj),

    },
    IP_symptom: [],
    IP_examination: [],
    IP_proviDig: [],
    IP_Dignosis: [],
    IP_notes: [],
    entChartNote: '',
    ENTImage: '',
    clinicalHis: {},
    painChart: [],
    pastHis: [],
    finalDig: [],
    obstric: {},
}
export default function CollabOPTDocNotes(props) {
    const [patient_id, setpatient_id] = useState(null)
    const [docNotes, setdocNotes] = useState(doctorNote);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [clinicID, setclinicID] = useState(null);
    const [notesLayout, setnotesLayout] = useState({});
    const [isNewOtherDoc, setIsNewOtherDoc] = useState(false);
    const [other_investigation, setOther_investigation] = useState(OTHER_INVESTIGATION_CONFIG_DATA);
    const UserData = JSON.parse(localGetItem("loggedInUserInfo"))

    useEffect(() => {
        try {
            getNotesLayoutData();
            const cachedData = getCachevalue('DoctorPatientData');
            const appointData = JSON.parse(cachedData);
            const clinicId = getCachevalue('SelectedDoctorClinic')
            setIsNewOtherDoc(false);
            if (appointData?.patient_id) {
                setpatient_id(appointData.patient_id);
            }
            if (clinicId) {
                setclinicID(clinicId)
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }, []);

    const createEyeTypeMap = (glassprespData = []) => {
        return glassprespData.reduce((acc, item) => {
            if (item.eye_type) acc[item.eye_type] = item;
            return acc;
        }, {});
    };

    const getNotesLayoutData = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_LAYOUT + `?doctor_id=${doctorID}&is_collabrative=true`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        if (props?.isNewOPT) {
                            let FinalData = NEW_DOC_NOTES_FOR_COLLAB_SUMMARY
                            setnotesLayout(FinalData);
                        } else {
                            let LeftData = response.data.data?.field_data?.left_data || []
                            let RightData = response.data.data?.field_data?.right_data || []
                            let FinalData = [...LeftData, ...RightData]
                            setnotesLayout(FinalData);
                        }
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    }
                    else {
                        errorMessage(error.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
    }
    const errorMessage = (msg) => {
        seterrorMsg(true)
        seterrorMsgText(msg)
    }

    async function setBackgroundImage(doc_key, key) {
        try {
            const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key));
            if (response.data.status === "success") {
                const Data = response?.data;
                setdocNotes((prevData) => ({
                    ...prevData,
                    [key]: Data?.data,
                }));
            }
        } catch (e) {
            errorMessage("Error fetching S3 URL")
        }
    }

    const fetchData = (url, query, handleResponse) => {
        RestAPIService.getAll(`${Serviceurls[url]}${query}`)
            .then((response) => {
                if (response.data.status === 'success') {
                    handleResponse(url === 'DOC_DOCTOR_NOTES_GONIOSCOPY' ? response.data.Gonioscopy_data : response.data.data);
                }
            }).catch((error) => {
                if (error?.response?.data?.message) {
                    errorMessage(error.response.data.message)
                } else {
                    errorMessage(error.message)
                }
            })
    }

    const { id, isProgrammaticScroll, details, doctorID } = props;

    const getNoteData = (section, name) => {
        const idKey = details?.visit_type !== "OP" ? "ip_admission_id=" + details?.admission_id : "appointment_id=" + details?.appointment_id;
        const query = section === 'counselling' ? `?patient_id=${patient_id}&${idKey}&clinic_id=${clinicID}` : `?patient_id=${patient_id}&${idKey}`;
        switch (section) {
            case "previous_glass_power":
                fetchData(
                    props?.isNewOPT ? "NEW_DOC_NOTES_PREV_GLASS_POWER" : "DOC_PREVIOUS_GLASS_POWER",
                    query,
                    (data) => {
                        let List = []
                        let lens_type = "";
                        let date = "";
                        if (props?.isNewOPT) {
                            List = data?.pgp ? data?.pgp : []
                            lens_type = data?.lens_type ? data?.lens_type : "";
                            date = data?.date ? data?.date : "";
                        } else {
                            List = data?.previous_glass_power ? data?.previous_glass_power : []
                        }

                        let temp_date = "";
                        let temp_frame_type = "";

                        for (var i = 0; i < List.length; i++) {
                            if (i == 0) {
                                temp_date = List[i].date
                                temp_frame_type = List[i].frame_type
                            } else {
                                List[i].date = temp_date
                                List[i].frame_type = temp_frame_type
                            }
                        }

                        var left = []; var Right = [];
                        if (List[0] && List[1]) {
                            if (List[0]?.eye_type == "LE") {
                                left.push(List[0])
                            } else {
                                Right.push(List[0])
                            }
                            if (List[1]?.eye_type == "RE") {
                                Right.push(List[1])
                            } else {
                                left.push(List[1])
                            }
                        } else if (List[0]) {
                            if (List[0]?.eye_type == "LE") {
                                left.push(List[0])
                            } else {
                                Right.push(List[0])
                            }
                        }
                        setdocNotes((prevData) => ({
                            ...prevData,
                            pgp: {
                                left_data: left,
                                right_data: Right,
                                date: temp_date ? temp_date : new Date(),
                                frameType: temp_frame_type,
                                lens_type: lens_type
                            },
                        }));
                    }
                );
                break;
            case "subjective_refraction":
                fetchData(
                    props?.isNewOPT ? "NEW_DOC_NOTES_SUB_REFRACTION" : "DOC_SUBJECTIVEREFRACTION",
                    query,
                    (data) => {
                        let List = props?.isNewOPT ? (data.subref || []) : (data.subrefraction || []);

                        let temp_occupation = "";
                        let temp_chart_used = "";
                        let temp_muscle = "";

                        for (var i = 0; i < List.length; i++) {
                            if (i == 0) {
                                temp_occupation = List[i].occupation
                                temp_chart_used = List[i].chart_used
                                temp_muscle = List[i].muscle
                            } else {
                                List[i].occupation = temp_occupation
                                List[i].chart_used = temp_chart_used
                                List[i].muscle = temp_muscle
                            }
                        }

                        var templateDataLeft = [];
                        var templateDataRight = [];
                        if (List.length > 0) {
                            List.forEach(item => {
                                if (item.eye_type === "LE") {
                                    templateDataLeft.push(item);
                                } else if (item.eye_type === "RE") {
                                    templateDataRight.push(item);
                                }
                            });
                        }
                        setdocNotes((prevData) => ({
                            ...prevData,
                            subjective_refraction: {
                                left_data: templateDataLeft,
                                right_data: templateDataRight,
                                occupation: temp_occupation,
                                chart: temp_chart_used,
                                muscle: temp_muscle,
                                comments: data.comment ? data?.comment : ""
                            },
                        }));
                    }
                );
                break;
            case "retinoscopic_refraction":
                if (props?.isNewOPT) {
                    fetchData(
                        "NEW_DOC_NOTES_RETINO_REFRACTION",
                        query,
                        (data) => {
                            let retinoList = Object.keys(data)?.length > 0 ? data : {}
                            let bfreDil = [
                                { "eye_type": "RE", "SPH": "", "CYL": "", "AXIS": "", "UCVA": "", "BCDVA": "", "BCNVA": "", "add": "" },
                                { "eye_type": "LE", "SPH": "", "CYL": "", "AXIS": "", "UCVA": "", "BCDVA": "", "BCNVA": "", "add": "" },
                            ]
                            let aftrDil = [
                                { "eye_type": "RE", "SPH": "", "CYL": "", "AXIS": "", "UCVA": "", "BCDVA": "", "BCNVA": "", "add": "" },
                                { "eye_type": "LE", "SPH": "", "CYL": "", "AXIS": "", "UCVA": "", "BCDVA": "", "BCNVA": "", "add": "" },
                            ]
                            setdocNotes((prev) => ({
                                ...prev,
                                retinoscopic_refraction: {
                                    beforeDilation: Object.keys(retinoList)?.length > 0 ? retinoList?.before_dilation : bfreDil,
                                    afterDilation: Object.keys(retinoList)?.length > 0 ? retinoList?.after_dilation : aftrDil,
                                    retinoComments: Object.keys(retinoList)?.length > 0 ? retinoList?.comment : '',
                                }
                            }))

                        })

                } else {
                    fetchData(
                        "DOC_RETINOSCOPICREFRACTION",
                        query,
                        (data) => {
                            let List = data.additional_subrefraction || [];

                            let temp_occupation = "";
                            let temp_chart_used = "";
                            let temp_muscle = "";

                            for (var i = 0; i < List.length; i++) {
                                if (i == 0) {
                                    temp_occupation = List[i].occupation
                                    temp_chart_used = List[i].chart_used
                                    temp_muscle = List[i].muscle
                                } else {
                                    List[i].occupation = temp_occupation
                                    List[i].chart_used = temp_chart_used
                                    List[i].muscle = temp_muscle
                                }
                            }

                            var templateDataLeft = [];
                            var templateDataRight = [];
                            if (List.length > 0) {
                                List.forEach(item => {
                                    if (item.eye_type === "LE") {
                                        templateDataLeft.push(item);
                                    } else if (item.eye_type === "RE") {
                                        templateDataRight.push(item);
                                    }
                                });
                            }
                            setdocNotes((prevData) => ({
                                ...prevData,
                                retinoscopic_refraction: {
                                    left_data: templateDataLeft,
                                    right_data: templateDataRight,
                                    occupation: temp_occupation,
                                    chart: temp_chart_used,
                                    muscle: temp_muscle
                                },
                            }));
                        }
                    );
                }
                break;
            case "retinoscopic_acceptance":
                fetchData(
                    "OPT_RETINOSCOPIC_ACCEPTANCE",
                    query,
                    (data) => {
                        let List = data.retacceptance || [];

                        let temp_occupation = "";
                        let temp_chart_used = "";
                        let temp_muscle = "";

                        for (var i = 0; i < List.length; i++) {
                            if (i == 0) {
                                temp_occupation = List[i].occupation
                                temp_chart_used = List[i].chart_used
                                temp_muscle = List[i].muscle
                            } else {
                                List[i].occupation = temp_occupation
                                List[i].chart_used = temp_chart_used
                                List[i].muscle = temp_muscle
                            }
                        }

                        var templateDataLeft = [];
                        var templateDataRight = [];
                        if (List.length > 0) {
                            List.forEach(item => {
                                if (item.eye_type === "LE") {
                                    templateDataLeft.push(item);
                                } else if (item.eye_type === "RE") {
                                    templateDataRight.push(item);
                                }
                            });
                        }
                        setdocNotes((prevData) => ({
                            ...prevData,
                            retinoscopic_acceptance: {
                                left_data: templateDataLeft,
                                right_data: templateDataRight,
                                occupation: temp_occupation,
                                chart: temp_chart_used,
                                muscle: temp_muscle
                            },
                        }));
                    }
                );
                break;
            case "vision_assesment":
                fetchData(
                    props?.isNewOPT ? "NEW_DOC_NOTES_VISSION_ASSESSMENT" : "DOC_OPT_VISIONASSESSMENT",
                    query,
                    (data) => {
                        let List = props?.isNewOPT ? (data.vision_data || []) : (data.vision_assessment || []);
                        let selectedChartUsed = data.chart_used ? data?.chart_used : null;
                        let selectedOccupation = data.occupation ? data?.occupation : null;
                        let selectedComment = data.comments ? data?.comments : null;
                        const leftEyeList = [];
                        const rightEyeList = [];
                        let leftEyeId = null;
                        let rightEyeId = null;
                        if (List.length === 1) {
                            if (List[0].eye_type === 'LE') {
                                leftEyeList.push(List[0]);
                                leftEyeId = List[0].id;
                            } else if (List[0].eye_type === 'RE') {
                                rightEyeList.push(List[0]);
                                rightEyeId = List[0].id;
                            }
                        } else if (List.length === 2) {
                            List.forEach((item) => {
                                if (item.eye_type === 'LE') {
                                    leftEyeList.push(item);
                                    leftEyeId = item.id;
                                } else if (item.eye_type === 'RE') {
                                    rightEyeList.push(item);
                                    rightEyeId = item.id;
                                }
                            });
                        }
                        setdocNotes((prevData) => ({
                            ...prevData,
                            vision_assesment: {
                                left_data: leftEyeList,
                                right_data: rightEyeList,
                                chart: selectedChartUsed,
                                occupation: selectedOccupation,
                                comment: selectedComment,
                            },
                        }));
                    }
                );
                break;
            case "ocular_response_analyzer":
                fetchData(
                    props?.isNewOPT ? "NEW_DOC_NOTES_OCULAR_RESP_ANALYSER" : "DOC_OCULAR_RESPONSER",
                    query,
                    (data) => {
                        let List = props?.isNewOPT ? (data?.ocular_response || []) : (data || []);
                        var left = []; var Right = [];
                        if (List[0] && List[1]) {
                            if (List[0]?.eye_type == "LE") {
                                left.push(List[0])
                            } else {
                                Right.push(List[0])
                            }
                            if (List[1]?.eye_type == "RE") {
                                Right.push(List[1])
                            } else {
                                left.push(List[1])
                            }
                        } else if (List[0]) {
                            if (List[0]?.eye_type == "LE") {
                                left.push(List[0])
                            } else {
                                Right.push(List[0])
                            }
                        }
                        setdocNotes((prevData) => ({
                            ...prevData,
                            ocular_response_analyzer: {
                                left_data: left,
                                right_data: Right,
                                comments: data?.comments ? data?.comments : ""
                            },
                        }));
                    }
                );
                break;
            case "intraocular_pressure":
                fetchData(
                    props?.isNewOPT ? "NEW_DOC_NOTES_INTRAOCULAR_PRESSURE" : "DOC_INTRAOCULARPRESSURE",
                    query,
                    (data) => {
                        let IOP = props?.isNewOPT ? (data?.intraocular || []) : (data.ophthalmology_iop || []);
                        var left = []; var Right = [];
                        if (IOP[0] && IOP[1]) {
                            if (IOP[0]?.eye_type == "LE") {
                                left.push(IOP[0])
                            } else {
                                Right.push(IOP[0])
                            }
                            if (IOP[1]?.eye_type == "RE") {
                                Right.push(IOP[1])
                            } else {
                                left.push(IOP[1])
                            }
                        } else if (IOP[0]) {
                            if (IOP[0]?.eye_type == "LE") {
                                left.push(IOP[0])
                            } else {
                                Right.push(IOP[0])
                            }
                        }
                        setdocNotes((prevData) => ({
                            ...prevData,
                            intraocular_pressure: {
                                left_data: left,
                                right_data: Right,
                                comments: data?.comment ? data?.comment : ""
                            },
                        }));

                    }
                );
                break;
            case "auto_refractory":
                fetchData(
                    "DOC_AUTO_REFRACTOMETRY",
                    query,
                    (data) => {
                        let List = data?.auto_refractometry ? data?.auto_refractometry : [];
                        let BeforeDilationRE = []
                        let AfterDilationRE = []
                        let BeforeDilationLE = []
                        let AfterDilationLE = []
                        let Comments = List?.length ? (data?.auto_refractometry[0]?.comments || '') : "";
                        for (var i = 0; i < List.length; i++) {
                            if (List[i].is_before_dilation == true && List[i].eye_type == "RE") {
                                BeforeDilationRE.push(List[i])
                            } else if (List[i].is_before_dilation == true && List[i].eye_type == "LE") {
                                BeforeDilationLE.push(List[i])
                            } else if (List[i].is_before_dilation == false && List[i].eye_type == "RE") {
                                AfterDilationRE.push(List[i])
                            } else if (List[i].is_before_dilation == false && List[i].eye_type == "LE") {
                                AfterDilationLE.push(List[i])
                            }
                        }

                        setdocNotes((prevData) => ({
                            ...prevData,
                            auto_refractory: {
                                BeforeDilationRE: BeforeDilationRE,
                                BeforeDilationLE: BeforeDilationLE,
                                AfterDilationRE: AfterDilationRE,
                                AfterDilationLE: AfterDilationLE,
                                Comments: Comments,
                            },
                        }));

                    }
                );
                break;
            case "anterior_segment":
                fetchData(
                    props?.isNewOPT ? "NEW_DOC_NOTES_ANTERIOR_SEGMENT" : "DOC_ANTERIOR_SEGMENT_API",
                    query,
                    (data) => {
                        let List = data ? data : [];
                        let LidsRightEye = [];
                        let ConjunctivaRightEye = [];
                        let ScleraRightEye = [];
                        let CorneaRightEye = [];
                        let AnteriorChambRightEye = [];
                        let PupilRightEye = [];
                        let IrisRightEye = [];
                        let LensRightEye = [];
                        let ExtraocularRightEye = [];
                        let LidsLeftEye = [];
                        let ConjunctivaLeftEye = [];
                        let ScleraLeftEye = [];
                        let CorneaLeftEye = [];
                        let AnteriorChambLeftEye = [];
                        let PupilLeftEye = [];
                        let IrisLeftEye = [];
                        let ExtraocularLeftEye = [];
                        let LensLeftEye = [];
                        var left = []; var Right = [];
                        let Comments = '';
                        if (props?.isNewOPT) {
                            let anteriorData = Object.keys(data)?.length > 0 ? data : {}
                            setdocNotes((prevData) => ({
                                ...prevData,
                                anterior_segment: {
                                    anteriorComments: Object.keys(anteriorData)?.length > 0 ? anteriorData?.comments : '',
                                    LidsRightEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.lids : '',
                                    AnteriorChambRightEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.anterior_chamber : '',
                                    ScleraRightEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.sclera : '',
                                    ConjunctivaRightEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.conjuctiva : '',
                                    PupilRightEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.pupil : '',
                                    CorneaRightEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.cornea : '',
                                    IrisRightEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.iris : '',
                                    LensRightEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.lens : '',
                                    ExtraocularRightEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.extra_ocular : '',
                                    Right: Object.keys(anteriorData)?.length > 0 ? JSON.stringify(anteriorData?.right_eye) : '',

                                    LidsLeftEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.lids : '',
                                    AnteriorChambLeftEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.anterior_chamber : '',
                                    ScleraLeftEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.sclera : '',
                                    ConjunctivaLeftEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.conjuctiva : '',
                                    PupilLeftEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.pupil : '',
                                    CorneaLeftEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.cornea : '',
                                    IrisLeftEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.iris : '',
                                    LensLeftEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.lens : '',
                                    ExtraocularLeftEye: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.extra_ocular : '',
                                    left: Object.keys(anteriorData)?.length > 0 ? JSON.stringify(anteriorData?.left_eye) : ''
                                }
                            }))
                        } else {
                            if (List[0] && List[1]) {
                                if (List[0]?.eye_type == "LE") {
                                    left.push(List[0])
                                } else {
                                    Right.push(List[0])
                                }
                                if (List[1]?.eye_type == "RE") {
                                    Right.push(List[1])
                                } else {
                                    left.push(List[1])
                                }
                            } else if (List[0]) {
                                if (List[0]?.eye_type == "LE") {
                                    left.push(List[0])
                                } else {
                                    Right.push(List[0])
                                }
                            }
                            if (Right.length > 0) {
                                LidsRightEye = Right[0]?.lids;
                                ConjunctivaRightEye = Right[0]?.conjuctiva;
                                ScleraRightEye = Right[0]?.sclera;
                                CorneaRightEye = Right[0]?.cornea;
                                AnteriorChambRightEye = Right[0]?.anterior_chamber;
                                PupilRightEye = Right[0]?.pupil;
                                IrisRightEye = Right[0]?.iris;
                                LensRightEye = Right[0]?.lens;
                                ExtraocularRightEye = Right[0]?.extra_ocular;
                            }
                            if (left.length > 0) {
                                LidsLeftEye = left[0]?.lids;
                                ConjunctivaLeftEye = left[0]?.conjuctiva;
                                ScleraLeftEye = left[0]?.sclera;
                                CorneaLeftEye = left[0]?.cornea;
                                AnteriorChambLeftEye = left[0]?.anterior_chamber;
                                PupilLeftEye = left[0]?.pupil;
                                IrisLeftEye = left[0]?.iris;
                                LensLeftEye = left[0]?.lens;
                                ExtraocularLeftEye = left[0]?.extra_ocular;
                            }
                            setdocNotes((prevData) => ({
                                ...prevData,
                                anterior_segment: {
                                    ...prevData.anterior_segment,
                                    LidsRightEye, ConjunctivaRightEye, ScleraRightEye, CorneaRightEye, AnteriorChambRightEye, PupilRightEye, IrisRightEye, LensRightEye, ExtraocularRightEye,
                                    ScleraLeftEye, CorneaLeftEye, AnteriorChambLeftEye, PupilLeftEye, IrisLeftEye, ExtraocularLeftEye, LensLeftEye, LidsLeftEye, ConjunctivaLeftEye,
                                },
                            }));
                        }

                    }
                );
                break;
            case "posterior_segment":
                fetchData(
                    props?.isNewOPT ? "NEW_DOC_NOTES_POSTERIOR_SEGMENT" : "DOC_DOCTOR_NOTES_POSTERIOR_SEGMENT",
                    query,
                    (data) => {
                        let PosteriorData = data ? data : [];

                        var states = docNotes?.posterior_segment
                        if (props?.isNewOPT) {
                            let postData = Object?.keys(data)?.length > 0 ? data : {}
                            setdocNotes((prevData) => ({
                                ...prevData,
                                posterior_segment: {
                                    ...prevData?.posterior_segment,
                                    discLeftEye: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.disc : '',
                                    maculaLeftEye: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.macula : '',
                                    mediaLeftEye: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.media : '',
                                    vesselsLeftEye: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.vessels : '',
                                    peripheryLeftEye: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.periphery : '',
                                    discRightEye: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.disc : '',
                                    maculaRightEye: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.macula : '',
                                    mediaRightEye: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.media : '',
                                    vesselsRightEye: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.vessels : '',
                                    peripheryRightEye: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.periphery : '',
                                    posteriorComments: Object?.keys(postData)?.length > 0 ? postData?.comments : '',
                                }
                            }))
                        } else {
                            for (let i = 0; i < PosteriorData.length; i++) {
                                if (PosteriorData[i].eye_type == "RE") {
                                    states["discRightEye"] = PosteriorData[i].disc;
                                    states["maculaRightEye"] = PosteriorData[i].macula;
                                    states["mediaRightEye"] = PosteriorData[i].media;
                                    states["vesselsRightEye"] = PosteriorData[i].vessels;
                                    states["peripheryRightEye"] = PosteriorData[i].periphery;
                                } else if (PosteriorData[i].eye_type == "LE") {
                                    states["discLeftEye"] = PosteriorData[i].disc;
                                    states["maculaLeftEye"] = PosteriorData[i].macula;
                                    states["mediaLeftEye"] = PosteriorData[i].media;
                                    states["vesselsLeftEye"] = PosteriorData[i].vessels;
                                    states["peripheryLeftEye"] = PosteriorData[i].periphery;
                                }
                            }
                            setdocNotes((prevData) => ({
                                ...prevData,
                                posterior_segment: states,
                            }));
                        }
                    });
            case "anterior_segment_diagram":
                fetchData(
                    "OPTHALMOLOGY_ANTERIOR_SEGMENT_IMAGE",
                    query,
                    (data) => {
                        var Anterior = data ? data : [];
                        try {
                            if (Anterior.anterior_image_key) {
                                setBackgroundImage(Anterior.anterior_image_key, "anterior_segment_diagram");
                            }
                        } catch (e) {

                        }
                    }
                );
                break;
            case "fundus":
                fetchData(
                    "DOC_OPT_FUNDUS_IMG",
                    query,
                    (data) => {
                        var FundasImg = data ? data : [];
                        try {
                            if (FundasImg.fundus_image_key) {
                                setBackgroundImage(FundasImg.fundus_image_key, "fundus");
                            }
                        } catch (e) {

                        }
                    }
                );
                break;
            case "keratomentry":
                fetchData(
                    props?.isNewOPT ? "NEW_DOC_NOTES_KERATOMENTRY" : "DOC_KERATOMETRY",
                    query,
                    (data) => {
                        if (props?.isNewOPT) {
                            let ketoData = Object.keys(data)?.length > 0 ? data : {}
                            let ketoArray = [
                                { label: 'Dioptre - RE', k1_value: '', k2_value: '', average_value: '', cylindrical_value: '', eye_type: 'RE' },
                                { label: 'MM - RE', k1_value: '', k2_value: '', average_value: '', cylindrical_value: '', eye_type: 'RE' },
                                { label: 'Dioptre - LE', k1_value: '', k2_value: '', average_value: '', cylindrical_value: '', eye_type: 'LE' },
                                { label: 'MM - LE', k1_value: '', k2_value: '', average_value: '', cylindrical_value: '', eye_type: 'LE' }
                            ]
                            setdocNotes((prevData) => ({
                                ...prevData,
                                keratomentry: {
                                    keratomentryData: Object.keys(ketoData)?.length > 0 ? ketoData?.keratomentry : ketoArray,
                                    keratoComments: Object.keys(ketoData)?.length > 0 ? ketoData?.comments : '',
                                }
                            }))
                        } else {
                            let List = data || [];
                            setdocNotes((prevData) => ({
                                ...prevData,
                                keratomentry: {
                                    left_data: List.filter((item) => (item?.eye_type === "LE")),
                                    right_data: List.filter((item) => (item?.eye_type === "RE")),
                                },
                            }));
                        }
                    }
                );
                break;
            case "IOLMaster":
                fetchData(
                    props?.isNewOPT ? "NEW_DOC_NOTES_IOL_MASTER" : "DOC_NOTES_IOL_MASTER",
                    query,
                    (data) => {
                        if (props?.isNewOPT) {
                            let iolData = data !== null ? data : {}
                            setdocNotes((prevData) => ({
                                ...prevData,
                                IOLMaster: Object.keys(iolData)?.length > 0 ? iolData?.iol_data : UMA_IOL_MASTER_LIST,
                                iolComments: Object.keys(iolData)?.length > 0 ? iolData?.comments : '',
                            }))
                        } else {
                            setdocNotes((prevData) => ({
                                ...prevData,
                                IOLMaster: data?.length > 0 ? data : [],
                            }));
                        }
                    }
                );
                break;
            case "other_investigation":
                fetchData(
                    "DOC_OTHER_INVESTIGATION",
                    query,
                    (data) => {
                        let Investigation = data ? data : []

                        var states = docNotes?.other_investigation
                        if (Investigation.length > 0) {
                            for (let i = 0; i < Investigation.length; i++) {
                                if (Investigation[i].eye_type == "RE") {
                                    states["WFDTRightEye"] = Investigation[i].wfdt;
                                    states["EOMRightEye"] = Investigation[i].eom;
                                    states["ColorVisionRightEye"] = Investigation[i].colour_vision;
                                    states["ConfrontationRightEye"] = Investigation[i].confrontation;
                                    states["PupilRightEye"] = Investigation[i].pupil;
                                    states["PachymentryRightEye"] = Investigation[i].pachymentry;
                                    states["SchirmerRightEye"] = Investigation[i].schirmers_test;
                                    states["ContrastRightEye"] = Investigation[i].contrast_sensitivity;
                                    states['SyringeRightEye'] = Investigation[i].syringe;
                                    states['AdditionalRightEye'] = Investigation[i].additional_details;
                                    states['DuctRightEye'] = Investigation[i].duct;
                                } else if (Investigation[i].eye_type == "LE") {
                                    states["WFDTLeftEye"] = Investigation[i].wfdt;
                                    states["EOMLeftEye"] = Investigation[i].eom;
                                    states["ColorVisionLeftEye"] = Investigation[i].colour_vision;
                                    states["ConfrontationLeftEye"] = Investigation[i].confrontation;
                                    states["PupilLeftEye"] = Investigation[i].pupil;
                                    states["PachymentryLeftEye"] = Investigation[i].pachymentry;
                                    states["SchirmerLeftEye"] = Investigation[i].schirmers_test;
                                    states["ContrastLeftEye"] = Investigation[i].contrast_sensitivity;
                                    states['SyringeLeftEye'] = Investigation[i].syringe;
                                    states['AdditionalLeftEye'] = Investigation[i].additional_details;
                                    states['DuctLeftEye'] = Investigation[i].duct;
                                }
                            }
                        }
                        setdocNotes((prevData) => ({
                            ...prevData,
                            other_investigation: states,
                        }));

                    }
                );
                break;
            case "gonioscopy":
                fetchData(
                    "DOC_DOCTOR_NOTES_GONIOSCOPY",
                    query,
                    (data) => {
                        let { itemList } = docNotes?.gonioscopy;
                        itemList = data ? data : [];
                        var data = itemList;
                        var availableEyeId = []

                        for (var i = 0; i < data.length; i++) {
                            var prepareData = {
                                "eye_type": data[i].eye_type,
                                "id": data[i].id,
                                "dilation": data[i].before_dilation == true ? "BeforeDilation" : "AfterDilation"
                            }
                            availableEyeId.push(prepareData);
                        }

                        var BeforeDilationRE = []
                        var AfterDilationRE = []
                        var BeforeDilationLE = []
                        var AfterDilationLE = []
                        for (var i = 0; i < data.length; i++) {
                            if (data[i].before_dilation == true && data[i].eye_type == "RE") {
                                BeforeDilationRE.push(data[i])
                            } else if (data[i].before_dilation == true && data[i].eye_type == "LE") {
                                BeforeDilationLE.push(data[i])
                            } else if (data[i].before_dilation == false && data[i].eye_type == "RE") {
                                AfterDilationRE.push(data[i])
                            } else if (data[i].before_dilation == false && data[i].eye_type == "LE") {
                                AfterDilationLE.push(data[i])
                            }
                        }

                        setdocNotes((prevData) => ({
                            ...prevData,
                            gonioscopy: {
                                B_R_Inferior: BeforeDilationRE[0]?.inferior_grade ? BeforeDilationRE[0].inferior_grade : "",
                                B_R_Nasal: BeforeDilationRE[0]?.nasal_grade ? BeforeDilationRE[0].nasal_grade : "",
                                B_R_Superior: BeforeDilationRE[0]?.superior_grade ? BeforeDilationRE[0].superior_grade : "",
                                B_R_Temporal: BeforeDilationRE[0]?.temporal_grade ? BeforeDilationRE[0].temporal_grade : "",
                                B_Comments: BeforeDilationRE[0]?.comments ? BeforeDilationRE[0].comments : BeforeDilationLE[0]?.comments ? BeforeDilationLE[0].comments : "",
                                B_L_Inferior: BeforeDilationLE[0]?.inferior_grade ? BeforeDilationLE[0].inferior_grade : "",
                                B_L_Nasal: BeforeDilationLE[0]?.nasal_grade ? BeforeDilationLE[0].nasal_grade : "",
                                B_L_Superior: BeforeDilationLE[0]?.superior_grade ? BeforeDilationLE[0].superior_grade : "",
                                B_L_Temporal: BeforeDilationLE[0]?.temporal_grade ? BeforeDilationLE[0].temporal_grade : "",
                                A_R_Inferior: AfterDilationRE[0]?.inferior_grade ? AfterDilationRE[0].inferior_grade : "",
                                A_R_Nasal: AfterDilationRE[0]?.nasal_grade ? AfterDilationRE[0].nasal_grade : "",
                                A_R_Superior: AfterDilationRE[0]?.superior_grade ? AfterDilationRE[0].superior_grade : '',
                                A_R_Temporal: AfterDilationRE[0]?.temporal_grade ? AfterDilationRE[0].temporal_grade : "",
                                A_Comments: AfterDilationRE[0]?.comments ? AfterDilationRE[0].comments : AfterDilationLE[0]?.comments ? AfterDilationLE[0].comments : "",
                                A_L_Inferior: AfterDilationLE[0]?.inferior_grade ? AfterDilationLE[0].inferior_grade : "",
                                A_L_Nasal: AfterDilationLE[0]?.nasal_grade ? AfterDilationLE[0].nasal_grade : "",
                                A_L_Superior: AfterDilationLE[0]?.superior_grade ? AfterDilationLE[0].superior_grade : "",
                                A_L_Temporal: AfterDilationLE[0]?.temporal_grade ? AfterDilationLE[0].temporal_grade : "",
                            },
                        }));

                    }
                );
                break;
            case "treatment_plan":
                fetchData(
                    "DOC_TREATMENT_ADVICE",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            treatment_plan: data?.treatment_advice?.comments ? data?.treatment_advice?.comments : '',
                        }));
                    }
                );
                break;
            case "diagnosis":
                fetchData(
                    "DOC_DOCTOR_NOTES_ASSESSEMENT",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            diagonis: {
                                diagonisDataList: JSON.parse(JSON.stringify(data?.icd_codes)),
                                provisional_diagnosis: data?.provisional_diagnosis ? data?.provisional_diagnosis : ''
                            }
                        }));
                    }
                );
                break;
            case "notes":
                fetchData(
                    "DOC_OVERALL_REVIEW_NOTES",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            notes: data?.comments ? data?.comments : '',
                        }));
                    }
                );
                break;
            case "optometry_notes":
                fetchData(
                    "DOC_DOCTOR_NOTES_OPTHOMETRY_NOTES",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            optometry_notes: data?.opto_comments ? data?.opto_comments : "",

                        }));
                    }
                );
                break;
            case "oct_findings":
                fetchData(
                    "DOC_DOCTOR_NOTES_CLINICAL_HISTORY",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            oct_findings: data?.history ? data?.history : ""

                        }));
                    }
                );
                break;
            case "prescription":
                fetchData(
                    "DOC_OPT_TAPPER_DETAILS_GET_POST",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            prescription: data ? data : ""

                        }));
                    }
                );
                break;
            case "Patient Category":
                fetchData(
                    "DOC_DOCTOR_NOTES_PATIENT_CATEGORY",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            Patient_Category: data ? data : ""

                        }));
                    }
                );
                break;
            case "complaints":
                fetchData(
                    props?.isNewOPT ? "NEW_DOC_NOTES_COMPLAINTS" : "DOC_DOCTOR_NOTES_COMPLAINTS_GET",
                    query,
                    (data) => {
                        let Description = data?.complaint_description ? data?.complaint_description : '';
                        setdocNotes((prevData) => ({
                            ...prevData,
                            complaints: props?.isNewOPT ? (data?.data ? data?.data : "") : (data ? data : ""),
                            complainDescrp: Description,

                        }));
                    }
                );
                break;
            case "ocular_history":
                fetchData(
                    (UserData?.new_doctor_notes_template ? "NEW_DOC_NOTES_OCULAR_HISTORY" : "DOC_OCULAR_MEDICATION_GET"),
                    `${query}`,
                    (data) => {
                        if (UserData?.new_doctor_notes_template) {
                            setdocNotes((prevData) => ({
                                ...prevData,
                                ocular_history: {
                                    ...prevData.ocular_history,
                                    MedicationData: data?.medication ? data?.medication : [],
                                    ContactLensData : data?.contact_lens ? data?.contact_lens : [],
                                    OthersData : data?.others ? data?.others : [],
                                },
                            }));
                        } else {
                            setdocNotes((prevData) => ({
                                ...prevData,
                                ocular_history: {
                                    ...prevData.ocular_history,
                                    MedicationData: data ? data : [],
                                },
                            }));
                        }
                    }
                )
                fetchData(
                    "DOC_OCULAR_SURGERY_GET",
                    `${query}`,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            ocular_history: {
                                ...prevData.ocular_history,
                                SurgeryData: data ? data : [],
                            },
                        }));
                    }
                )
                break;
            case "systemic_illness":
                fetchData(
                    "DOC_OPT_LIST_ILLNESS",
                    `${query}`,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            systemic_illness: {
                                ...prevData.systemic_illness,
                                IllnessData: data ? data : [],
                            },
                        }));
                    }
                )
                fetchData(
                    "DOC_OPT_DRUG_ALLERGY",
                    `${query}`,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            systemic_illness: {
                                ...prevData.systemic_illness,
                                AllergyData: data?.data ? data?.data : [],
                            },
                        }));
                    }
                )
                break;
            case "review_plan":
                fetchData(
                    "DOC_OPT_REVIEW_PALN",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            review_plan: {
                                ReviewData: data?.review_plan ? [data?.review_plan] : ""
                            }

                        }));
                    }
                );
                break;
            case "investigations":
                fetchData(
                    "DOC_TEST_GET",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            investigations: {
                                Testdata: data?.length > 0 ? data?.map((item) => ({
                                    ...item,
                                    display_label: item?.lab_test_names ? item?.lab_test_names :
                                        item?.lab_set_names ? item?.lab_set_names :
                                            item?.special_test_name ? item?.special_test_name :
                                                item?.service_name ? item?.service_name :
                                                    item?.package_name ? item?.package_name : ""
                                })) : []
                            }

                        }));
                    }
                );
                break;
            case "schirmer_test":
                fetchData(
                    "DOC_SCHIRMER_API",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            schirmer_test: data?.length > 0 ? data[0] : {}
                        }));
                    }
                );
                break;
            case "vitals":
                let clinicData = getCachevalue("SelectedDoctorClinic") ? JSON.parse(getCachevalue("SelectedDoctorClinic")) : null;
                if (props?.isNewOPT) {
                    setdocNotes((prevData) => ({
                        ...prevData,
                        vitals: {
                            ...prevData.vitals,
                            filteredRightField_data: [
                                { field_name: "height", is_active: true },
                                { field_name: "weight", is_active: true },
                                { field_name: "bpsystolic", is_active: true },
                                { field_name: "bpdistolic", is_active: true },
                                { field_name: "temp", is_active: true },
                                { field_name: "spo2", is_active: true },
                                { field_name: "pulse", is_active: true },
                                { field_name: "blood_glucose", is_active: true }
                            ]
                            ,
                        },
                    }));
                } else {
                    fetchData(
                        "VITALS_CONFIGURATION",
                        `${query}&clinic_id=${clinicData}`,
                        (data) => {
                            setdocNotes((prevData) => ({
                                ...prevData,
                                vitals: {
                                    ...prevData.vitals,
                                    filteredRightField_data: data?.length > 0 ? data[0]?.vital_layout_data : [],
                                },
                            }));
                        }
                    )
                }

                fetchData(
                    "DOC_DOCTOR_NOTES_VITALS",
                    `${query}`,
                    (data) => {
                        if (data?.length) {
                            setdocNotes((prevData) => ({
                                ...prevData,
                                vitals: {
                                    ...prevData.vitals,
                                    ...data?.length > 0 ? data[0] : {},
                                    height: data[0]?.height_cm,
                                    weight: data[0]?.weight_kg,
                                    bp_d: data[0]?.blood_pressure_diastolic,
                                    bp_s: data[0]?.blood_pressure_systolic,
                                    temp: data[0]?.temperature,
                                    spo2: data[0]?.pulse_oximetry,
                                    pulserate: data[0]?.pulse_rate,
                                    bloodglucouse: data[0]?.blood_sugar,
                                    tempUnit: data[0]?.temperature_unit,
                                    bmi: data[0]?.bmi,
                                    bsa: data[0]?.bsa,
                                    obs_ExpectedDeliveryDate: data[0]?.expected_date_of_delivery || null,
                                    DeliverydateCalac: data[0]?.expected_date_of_delivery ? true : false,
                                    GestationalCalculation: (data[0]?.gestational_age_weeks || data[0]?.gestational_age_days) ? true : false,
                                    obs_LastMenstrualPeriod: data[0]?.last_menstrual_period || null,
                                    gestational_weeks: data[0]?.gestational_age_weeks,
                                    gestational_days: data[0]?.gestational_age_days,
                                    headCircumference: data[0]?.head_circumference,
                                    waist_circumference: data[0]?.waist_circumference,
                                    postLoading: true,
                                    loading: false,
                                    vitalDate: data[0]?.vital_entered_time ? data[0]?.vital_entered_time : new Date(),
                                    comments: data[0]?.comments,
                                    nurseName: data[0]?.nurse_name || "",

                                }
                            }));
                        }
                    }
                );
                break;
            case "glass_prescription":
                if (props?.isNewOPT) {
                    fetchData(
                        "NEW_DOC_NOTES_GLASS_PRESCRIPTION",
                        query,
                        (data) => {
                            let glassRef = Object.keys(data)?.length > 0 ? data : {}
                            let newArray = [
                                {
                                    "eye_type": "RE", 'DV_SPH': "", 'DV_CYL': "", 'DV_AXIS': "", 'DV_BCDVA': "",
                                    'NV_SPH': "", 'NV_CYL': "", 'NV_AXIS': "", 'NV_BCNVA': "",
                                },
                                {
                                    "eye_type": "LE", 'DV_SPH': "", 'DV_CYL': "", 'DV_AXIS': "", 'DV_BCDVA': "",
                                    'NV_SPH': "", 'NV_CYL': "", 'NV_AXIS': "", 'NV_BCNVA': "",
                                },
                            ]
                            setdocNotes((prev) => ({
                                ...prev,
                                glass_prescription: {

                                    glassprespData: Object.keys(glassRef)?.length > 0 ? glassRef?.prescription : newArray,
                                    selectedLensType: Object.keys(glassRef)?.length > 0 ? (glassRef?.lens_type || []) : [],
                                    selectedEyeWear: Object.keys(glassRef)?.length > 0 ? glassRef?.recommended_eye_wear : '',
                                    selectedLensMaterial: Object.keys(glassRef)?.length > 0 ? glassRef?.lens_material : '',
                                    selectedLens: Object.keys(glassRef)?.length > 0 ? glassRef?.continue_with_same_lense : '',
                                    selectedLensEnhacement: Object.keys(glassRef)?.length > 0 ? glassRef?.lens_enhancement : '',
                                    glassPrespComments: Object.keys(glassRef)?.length > 0 ? glassRef?.comment : '',
                                    sameGlass: Object.keys(glassRef)?.length > 0 ? glassRef?.same_glass : false,
                                    lensTypeList: UMA_LENS_TYPE,
                                }
                            }))
                        }
                    )
                } else {
                    fetchData(
                        "DOC_OPT_GLASS_PRESCRIPTION",
                        query,
                        (data) => {
                            const { Left, Right } = extractEyeData(data?.glass_prescription || []);
                            const { lens: SecData = {} } = data;
                            setdocNotes((prevData) => ({
                                ...prevData,
                                glass_prescription: {
                                    ...prevData.glass_prescription,
                                    templateDataLeft: Left ? [Left] : [],
                                    templateDataRight: Right ? [Right] : [],
                                    ...extractSecData(SecData),
                                }
                            }));
                        }
                    );
                }
                break;
            case "smile":
                fetchData(
                    "NEW_DOC_NOTES_SMILE",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            smile: {
                                SPHList: SPH_OPTIONS,
                                CYLList: CYL_OPTIONS,
                                AXISList: AXIS_OPTIONS,
                                BCDVAList: BCDVA_OPTIONS,
                                smileComments: data?.comment ? data?.comment : '',
                                underRefractionData: data?.under_refraction?.length > 0 ? data?.under_refraction : deepCopyFunc(commonArr),
                                acceptanceData: data?.acceptances?.length > 0 ? data?.acceptances : deepCopyFunc(commonArr),
                                overRefractionData: data?.over_refraction?.length > 0 ? data?.over_refraction : deepCopyFunc(commonArr),
                            }
                        }));
                    }
                );
                break;
            case "presyound":
                fetchData(
                    "NEW_DOC_NOTES_PRESBYOND",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            presbyond: {
                                SPHList: SPH_OPTIONS,
                                CYLList: CYL_OPTIONS,
                                AXISList: AXIS_OPTIONS,
                                BCDVAList: BCDVA_OPTIONS,
                                BCNVAList: BCNVA,
                                UCVAList: UCVA_OPTIONS,
                                id: data?.id,
                                comments: data?.comment ? data?.comment : '',
                                dominantEye: data?.dominant_eye ? data?.dominant_eye : 'RE',
                                refractionData: data?.refraction?.length > 0 ? data?.refraction : deepCopyFunc(refracArr),
                                eyeData: data?.bevn ? data?.bevn : deepCopyFunc(eyeObj),
                            }
                        }));
                    }
                );
                break;
            case "symptomsIP":
                fetchData(
                    "IP_DOCNOTES_SYMPTOMS",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            IP_symptom: data || [],
                        }));
                    }
                );
                break;
            case "examinationIP":
                fetchData(
                    "IP_DOCNOTES_EXAMINATION",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            IP_examination: data || [],
                        }));
                    }
                );
                break;
            case "proviDiagIP":
                fetchData(
                    "IP_DOCNOTES_PROVISIONAL_DIAG",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            IP_proviDig: data || [],
                        }));
                    }
                );
                break;
            case "diagnosisIP":
                fetchData(
                    "IP_DOCNOTES_DIAGNOSIS",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            IP_Dignosis: data || [],
                        }));
                    }
                );
                break;
            case "disNoteIP" || "FamilyCounIP" || "medicationIP":
                fetchData(
                    "IP_DOC_WRITE_NOTES",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            IP_notes: data || [],
                        }));
                    }
                );
                break;
        }
    };

    const extractEyeData = (data) => {
        const Left = data.find((item) => item.eye_type === 'LE');
        const Right = data.find((item) => item.eye_type !== 'LE');

        return { Left, Right };
    };

    const extractSecData = (SecData) => {
        return {
            Chart: SecData.chart_used || "",
            coatingCom: SecData.coating || "",
            SelectedLens: SecData.continue_with_same_lense || "",
            lens_id: SecData.id || "",
            LensCoat: SecData.lens_coating || "",
            LensType: SecData.lens_type || "",
            Muscle: SecData.muscle || "",
            Occupation: SecData.occupation || "",
            wearingIns: SecData.wearing_instructions || "",
            sameGlass: SecData.same_glass || "",
            selectedCheck: SecData.same_glass ? true : false,
            disableRadio: SecData.same_glass ? true : false
        };
    };

    const renderIntraocularTable = (Heading, value, width) => {
        return (
            <div style={{ display: "flex", flexDirection: "column", width: width, alignItems: "flex-start" }}>
                <div style={{ marginBottom: "0.5vw" }}>{Heading}</div>
                <div style={{ fontSize: "0.9vw", fontWeight: "600" }}>{value ? value : "-"}</div>
            </div>
        )
    }
    const renderTextBox_anterior_segment = (key, suggestion) => {
        let states = docNotes?.anterior_segment
        return (
            <TextField
                inputProps={{ emed_tid: "" }}
                sx={{ width: '80%' }}
                disabled
                size='small'
                placeholder='Type Remark'
                autoComplete='off'
                value={states[key]}
            />
        )
    }

    const renderTextBox_posterior_segment = (key) => {
        let states = docNotes?.posterior_segment
        return (
            <TextField
                inputProps={{ emed_tid: "" }}
                sx={{ width: '80%' }}
                disabled
                size='small'
                placeholder='Type Remark'
                autoComplete='off'
                value={states[key]}
            />
        )
    }
    const renderClinicExamImage = (key) => {
        const screenWidth = window.innerWidth;
        const containerWidth = screenWidth >= 1440 ? "40vw" : screenWidth >= 768 ? "56vw" : "90vw";
        const sketchWidth = Math.min(screenWidth * 0.8, 570);
        const sketchHeight = (sketchWidth / 570) * 530;
        return (
            <div style={{ height: '100%', width: "100%" }}>
                <img src={docNotes[key]} alt='Image' style={{ width: "100%", height: "auto", objectFit: "contain" }} />
            </div>
        )
    }

    const inputIoLTextBox = (names, values, index, label, disable) => {
        try {
            return (
                <TextField
                    autoComplete='off'
                    size='small'
                    variant='standard'
                    sx={{ width: '10vw' }}
                    value={values}
                    InputProps={{ emed_tid: label, readOnly: true }}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderTextBox_other_investigation = (key, suggestion) => {
        let states = docNotes?.other_investigation
        return (
            <Autocomplete
                disabled
                size='small'
                sx={{ width: '80%' }}
                options={suggestion || []}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.label}
                value={states[key] ? states[key] : ""}
                clearIcon={false}
                renderInput={(params) => <TextField
                    {...params}
                    disabled
                    autoComplete="off"
                    sx={{ width: '80%' }}
                    size='small'
                    placeholder='Type Remark'
                />}
            />
        )
    }

    const renderGonioscopyImage = (label, Inferior, Nasal, Superior, Temporal) => {
        return (
            <Box>

                <Box style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", height: "30vh", margin: "1vw" }}>
                    {Superior.length > 15 ?
                        <Tooltip placement="top" title={Superior}>
                            <Typography sx={{ position: "absolute", top: "0vw", zIndex: 20 }}>{Superior.slice(0, 15)}</Typography>
                        </Tooltip> :
                        <Typography sx={{ position: "absolute", top: "0vw", zIndex: 20 }}>{Superior}</Typography>}
                    {Nasal.length > 15 ?
                        <Tooltip placement="top" title={Nasal}>
                            <Typography sx={{ position: "absolute", left: "-2.5vw", top: "6.3vw", zIndex: 20 }}>{Nasal.slice(0, 15)}</Typography>
                        </Tooltip> :
                        <Typography sx={{ position: "absolute", left: "-2.5vw", top: "6.3vw", zIndex: 20 }}>{Nasal}</Typography>}
                    {Temporal.length > 15 ?
                        <Tooltip placement="top" title={Temporal}>
                            <Typography sx={{ position: "absolute", right: "-2.5vw", top: "6.3vw", zIndex: 20 }}>{Temporal.slice(0, 15)}</Typography>
                        </Tooltip> :
                        <Typography sx={{ position: "absolute", right: "-2.5vw", top: "6.3vw", zIndex: 20 }}>{Temporal}</Typography>}
                    {Inferior.length > 15 ?
                        <Tooltip placement="top" title={Inferior}>
                            <Typography sx={{ position: "absolute", bottom: "0vw", zIndex: 20 }}>{Inferior.slice(0, 15)}</Typography>
                        </Tooltip> :
                        <Typography sx={{ position: "absolute", bottom: "0vw", zIndex: 20 }}>{Inferior}</Typography>}
                    <Box>
                        <img src={ImagePaths.GonioscopyImage.default} alt="GonioscopyImage" style={{ width: '12vw', height: '20vh' }} />
                    </Box>

                </Box>
                <Typography fontSize={'0.9vw'} fontWeight={600} padding={"0.5vw"}>{label}</Typography>
            </Box>

        )
    }

    const renderObgynDatePicker = (stateKey, disable) => {
        let states = docNotes?.vitals
        return (
            <Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        value={states[stateKey] ? states[stateKey] : null}
                        disabled
                        inputFormat='DD-MM-YYYY'
                        views={["year", "month", "day"]}
                        renderInput={(params) => <TextField
                            sx={{ width: "12dvw" }}
                            autoComplete='off'
                            onKeyDown={(e) => e.preventDefault()}
                            size='small' {...params} />}
                    />
                </LocalizationProvider>
            </Box>)

    }
    const renderTextBox = (names, value, width, endAdornment, placeholder, color) => {
        try {
            return (
                <TextField
                    size='small'
                    sx={{ width: width }}
                    name={names}
                    autoComplete='off'
                    value={value}
                    placeholder={placeholder}
                    inputProps={{ style: { color: color, fontWeight: '600' } }}
                    InputProps={{
                        endAdornment: names === 'temp' ?
                            <FormControl size='small'>
                                <Select
                                    sx={{ width: '3vw' }}
                                    variant='standard'
                                    value={docNotes?.vitals?.tempUnit}
                                    readOnly
                                >
                                    <MenuItem value={'F'}>{'°F'}</MenuItem>
                                    <MenuItem value={'C'}>{'°C'}</MenuItem>
                                </Select>
                            </FormControl>
                            :
                            <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{endAdornment}</Typography>
                        , readOnly: docNotes?.vitals?.postLoading
                    }}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }
    const renderSelect = (stateKey, list = [], showKey = "label", valueKey = "value") => {
        return (
          <Select
            sx={{ width: '12vw', fontSize: '0.95vw' }}
            size='small'
            value={docNotes?.vitals?.oxygen_source}
            disabled={true}
          >
            {list?.map((item) => (
              <MenuItem sx={{ fontSize: '0.95vw' }} key={item[valueKey]} value={item[valueKey]}>{item[showKey]}</MenuItem>
            ))}
          </Select>
        )
      }

    const bmiHelperText = (bmi) => {
        try {
            let message = null
            if (bmi <= 18.5) {
                message = 'Mild Thinness'
            } else if (bmi > 18.5 && bmi <= 25) {
                message = 'Normal'
            } else if (bmi > 25 && bmi <= 30) {
                message = 'Overweight'
            } else if (bmi > 30) {
                message = 'Obesity'
            }
            return message;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const bsaHelperText = (bsa) => {
        try {
            let message = null
            if (bsa < 1.4) {
                message = 'Below Normal'
            } else if (bsa >= 1.4 && bsa <= 2.4) {
                message = 'Normal Range'
            } else if (bsa > 2.4) {
                message = 'Above Normal'
            }
            return message;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const returnClassName = (items, key, Type) => {
        if (Type == "LensCoat") {
            return key && key?.includes(items) ? "eMed_Chip_OnClick" : "eMed_Chip_Border";
        } else {
            if (key) {
                let value = key.find(obj => obj?.value === items?.value);
                return value?.value ? "eMed_Chip_OnClick" : "eMed_Chip_Border";
            } else {
                return "eMed_Chip_Border"
            }
        }
    }

    const returnVarient = (items, key, Type) => {
        if (Type == "LensCoat") {
            return key && key.includes(items) ? "contained" : "outlined";
        } else {
            if (key) {
                let value = key.find(obj => obj?.value === items?.value);
                return value?.value ? "contained" : "outlined";
            }
        }
    }

    const renderChip = (values, key, Type) => {
        let states = docNotes?.glass_prescription
        return (
            <div style={{ maxHeight: "7vw", overflow: "scroll", marginLeft: "0.2vw" }}>
                <div style={{ display: "flex", flexWrap: "wrap", marginTop: "0.5vw" }}>
                    {
                        values && values.map((item, index) => (
                            <Chip
                                className={`eMed_chip ${returnClassName(item, key, Type)}`}
                                style={{ width: "8vw" }}
                                label={Type == "LensCoat" ? item : item?.value}
                                variant={returnVarient(item, key, Type)}
                                disabled
                                key={index}
                                clickable
                            />
                        ))
                    }
                </div>
            </div>
        )
    }

    const autocompleteTextBox = (names, values, options = [], optionLabel, placeholders, index, arr) => {
        try {
            return (
                <Autocomplete
                    disabled
                    clearIcon
                    size='small'
                    sx={{ width: '7dvw' }}
                    value={values || ""}
                    options={options}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionLabel] || ""}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder={placeholders}
                            InputProps={{
                                ...params.InputProps,
                                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                        />
                    )}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const commonTblCopyCompare = (label, enableCopy, enableCompare, openComparePopup, arrKey, prevArrKey) => {
        try {
            return (
                <Box component={'div'}>
                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <Typography className='doc_notes_header_card_font'>{label}</Typography>
                    </Box>
                    <Box component={'div'} border={'1px solid lightgray'} m={'0.5rem 0rem'}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow>
                                    {headers.map((text, idx) => (
                                        <TableCell className='doc_notes_tbl_header' key={idx}>{text}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {docNotes?.smile?.[arrKey]?.length > 0 ? docNotes?.smile[arrKey].map((item, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('SPH', item?.SPH, docNotes?.smile?.SPHList, 'label', 'SPH', index, arrKey)}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('CYL', item?.CYL, docNotes?.smile?.CYLList, 'label', 'CYL', index, arrKey)}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('AXIS', item?.AXIS, docNotes?.smile?.AXISList, 'label', 'AXIS', index, arrKey)}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('BCDVA', item?.BCDVA, docNotes?.smile?.BCDVAList, 'label', 'BCDVA', index, arrKey)}
                                            </TableCell>
                                        </TableRow>
                                    )
                                }) : <TableRow><TableCell align='center' colSpan={5}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const textBoxPresbyond = (names, values, placeholder, index, arr) => {
        try {
            return (
                <TextField
                    disabled
                    variant='outlined'
                    size='small'
                    sx={{ width: "4.85dvw" }}
                    value={values}
                    placeholder={placeholder}
                    InputProps={{
                        style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                    }}
                    name={names}
                    inputProps={{ maxLength: 50 }}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const commonTblCopyComparePresbyond = () => {
        try {
            return (
                <Box component={'div'} marginY={"0.625dvw"}>
                    <Box component={'div'} border={'1px solid lightgray'} m={'0.5rem 0rem'}>
                        <Table size='small'>
                            {renderHeader(headers)}
                            <TableBody>
                                {docNotes?.presbyond?.refractionData?.length > 0 ? docNotes?.presbyond?.refractionData?.map((item, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('UCVA', item?.UCVA, docNotes?.presbyond?.UCVAList, 'label', 'UCVA', index, "refractionData")}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('SPH', item?.SPH, docNotes?.presbyond?.SPHList, 'label', 'SPH', index, "refractionData")}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('CYL', item?.CYL, docNotes?.presbyond?.CYLList, 'label', 'CYL', index, "refractionData")}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('AXIS', item?.AXIS, docNotes?.presbyond?.AXISList, 'label', 'AXIS', index, "refractionData")}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {textBoxPresbyond('target', item?.target, 'Target', index, "refractionData")}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('BCDVA', item?.BCDVA, docNotes?.presbyond?.BCDVAList, 'label', 'BCDVA', index, "refractionData")}
                                            </TableCell>
                                        </TableRow>
                                    )
                                }) : <TableRow><TableCell align='center' colSpan={5}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderHeader = (headArr) => {
        return (
            <TableHead>
                <TableRow>
                    {headArr.map((text, idx) => (
                        <TableCell className='doc_notes_tbl_header' key={idx}>{text}</TableCell>
                    ))}
                </TableRow>
            </TableHead>
        )
    }

    const renderEyeData = () => {
        try {
            return (
                <Box component={'div'} marginBottom={"0.625dvw"}>
                    <Box component={'div'} border={'1px solid lightgray'} m={'0.5rem 0rem'}>
                        <Table size='small'>
                            {renderHeader(eyeHeaders)}
                            <TableBody>
                                <TableRow>
                                    <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>Distance</TableCell>
                                    <TableCell className='doc_notes_tbl_body_cell'>
                                        {autocompleteTextBox('distance', docNotes?.presbyond?.eyeData?.distance, docNotes?.presbyond?.BCDVAList, 'label', 'Distance', 0, "eyeData")}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>Near</TableCell>
                                    <TableCell className='doc_notes_tbl_body_cell'>
                                        {autocompleteTextBox('near', docNotes?.presbyond?.eyeData?.near, docNotes?.presbyond?.BCNVAList, 'label', 'Near', 0, "eyeData")}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const autocompleteTextBoxUMA = (names, values, options = [], optionLabel, placeholders, index, key) => {
        try {
            return (
                <Autocomplete
                    disabled
                    clearIcon
                    size='small'
                    sx={{ width: '10dvw' }}
                    value={values || ""}
                    options={options}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionLabel] || ""}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder={placeholders}
                            InputProps={{
                                ...params.InputProps, emed_tid: names,
                                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                        />
                    )}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const beforeDilationTable = () => {
        try {
            return (
                <Box component={'div'} mt={'0.5rem'}>
                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <Typography className='doc_notes_header_card_font'>Before Dilation</Typography>
                    </Box>
                    <Box component={'div'} border={'1px solid lightgray'} m={'0.5rem 0rem'}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {docNotes?.retinoscopic_refraction?.beforeDilation?.length > 0 ? docNotes?.retinoscopic_refraction?.beforeDilation?.map((item, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBoxUMA('SPH', item?.SPH, docNotes?.retinoscopic_refraction?.SPHList, 'label', 'SPH', index, 'Before')}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBoxUMA('CYL', item?.CYL, docNotes?.retinoscopic_refraction?.CYLList, 'label', 'CYL', index, 'Before')}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBoxUMA('AXIS', item?.AXIS, docNotes?.retinoscopic_refraction?.AXISList, 'label', 'AXIS', index, 'Before')}
                                            </TableCell>
                                        </TableRow>
                                    )
                                }) : <TableRow><TableCell align='center' colSpan={4}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const afterDilationScreen = () => {
        try {
            return (
                <Box component={'div'} mt={'0.5rem'}>
                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <Typography className='doc_notes_header_card_font'>After Dilation</Typography>
                    </Box>
                    <Box component={'div'} border={'1px solid lightgray'} m={'0.5rem 0rem'}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {docNotes?.retinoscopic_refraction?.afterDilation?.length > 0 ? docNotes?.retinoscopic_refraction?.afterDilation?.map((item, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBoxUMA('SPH', item?.SPH, docNotes?.retinoscopic_refraction?.SPHList, 'label', 'SPH', index)}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBoxUMA('CYL', item?.CYL, docNotes?.retinoscopic_refraction?.CYLList, 'label', 'CYL', index)}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBoxUMA('AXIS', item?.AXIS, docNotes?.retinoscopic_refraction?.AXISList, 'label', 'AXIS', index)}
                                            </TableCell>
                                        </TableRow>
                                    )
                                }) : <TableRow><TableCell align='center' colSpan={4}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }
    const glassprespMap = useMemo(
        () => createEyeTypeMap(docNotes?.glass_prescription?.glassprespData),
        [docNotes?.glass_prescription?.glassprespData]
    );
    const getEye = (type) => glassprespMap[type] || {};
    const rightEye = getEye('RE');
    const leftEye = getEye('LE');

    const renderTableHeaders = () => (
        <TableHead>
            <TableRow>
                <TableCell className='doc_notes_tbl_header' rowSpan={2} align='center' sx={{ borderBottom: '1px solid lightgray !important' }}></TableCell>
                <TableCell className='doc_notes_tbl_header' colSpan={4} align='center' sx={{ borderBottom: '1px solid lightgray !important', borderRight: '1px solid lightgray !important' }}>Right Eye</TableCell>
                <TableCell className='doc_notes_tbl_header' colSpan={4} align='center' sx={{ borderBottom: '1px solid lightgray !important' }}>Left Eye</TableCell>
            </TableRow>
            <TableRow>
                {['SPH', 'CYL', 'AXIS', 'VA', 'SPH', 'CYL', 'AXIS', 'VA']?.map((label, idx) => (
                    <TableCell key={idx} className="doc_notes_tbl_header"
                        sx={{
                            borderBottom: '1px solid lightgray !important',
                            ...(idx === 3 && { borderRight: '1px solid lightgray !important' })
                        }}>
                        {label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead >
    );

    const autocompleteTextBox2 = (names, values, options, placeholders) => {
        try {
            return (
                <Autocomplete
                    disabled
                    freeSolo
                    clearIcon
                    size='small'
                    sx={{ width: '20dvw', mr: '0.5rem' }}
                    value={values}
                    options={options}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.label}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={placeholders}
                            inputProps={{ ...params.inputProps, maxLength: 100 }}
                            InputProps={{
                                ...params.InputProps, emed_tid: { names },
                                // style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                        />
                    )}
                    renderOption={(props, item) => {
                        return (
                            <Box component={'div'} display={'flex'} justifyContent={'space-between'} key={props["data-option-index"]}>
                                <Box component="li" {...props} width={'100%'}>
                                    <Typography>{item?.label}</Typography>
                                </Box>
                                {names === 'selectedLens' ? null :
                                    item?.default ? null : <Button className='Common_Btn_Min_Width'
                                    ></Button>}
                            </Box>
                        )
                    }}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const autocompleteTextBoxGLASS = (eyeType, names, values, options = [], optionLabel, placeholders) => {
        try {
            return (
                <Autocomplete
                    disabled
                    clearIcon
                    size='small'
                    sx={{ width: '6dvw' }}
                    value={options.find(opt => opt?.label === values) || null}
                    options={options}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionLabel]}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder={placeholders}
                            InputProps={{
                                ...params.InputProps, emed_tid: { names },
                                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                        />
                    )}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderLables = (label, value) => {
        try {
            return (
                <Box display={'flex'} alignItems={'center'} margin={'0.5vw'}>
                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText} marginRight={'0.5vw'}>{label}:</Typography>
                    <Typography fontSize={'0.9vw'} fontWeight={600}>{value}</Typography>
                </Box>
            )
        }
        catch (error) {
            errorMessage(error.message)
        }
    }

    return (
        <Box marginLeft={'.5vw'} borderBottom={'1px solid #E3E2E2'} paddingBottom={"1vw"}>
            {details.visit_type === 'OP' ?
                <Box>
                    {notesLayout.length > 0 ? notesLayout?.map((item) => {
                        if (item.field_name === 'previous_glass_power' && item.is_active) {
                            return (
                                <Box>
                                    <TriggerApiOnView id={`previous_glass_power_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`previous_glass_power_${id}`} marginTop={'1vw'}>
                                            <Typography fontWeight={'bold'} fontSize={'1vw'}>Previous Glass Power</Typography>
                                            <Box sx={{ maxHeight: '15vw', overflow: 'auto', border: '1px solid lightgray' }} component={'div'}>
                                                <Table stickyHeader size='small'>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Eye</TableCell>
                                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>SPH</TableCell>
                                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>CYL</TableCell>
                                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>AXIS</TableCell>
                                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>BCDVA</TableCell>
                                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>ADD</TableCell>
                                                            {props?.isNewOPT ? <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}></TableCell> : <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>BCNVA</TableCell>}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {docNotes?.pgp?.right_data?.length > 0 ? docNotes?.pgp?.right_data?.map((item, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Right Eye</TableCell>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.SPH ? item?.SPH : '-'}</TableCell>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.CYL ? item?.CYL : '-'}</TableCell>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>
                                                                    {item?.AXIS ? item?.AXIS?.length > 10 ?
                                                                        <Tooltip placement='top' title={item?.AXIS}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS?.slice(0, 10) + '...'}</Typography>
                                                                        </Tooltip> :
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS}</Typography> : '-'}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {item?.BCDVA ? item?.BCDVA?.length > 10 ?
                                                                        <Tooltip placement='top' title={item?.BCDVA}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA?.slice(0, 10) + '...'}</Typography>
                                                                        </Tooltip> :
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA}</Typography> : '-'}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {item?.add ? item?.add?.length > 10 ?
                                                                        <Tooltip placement='top' title={item?.add}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add?.slice(0, 10) + '...'}</Typography>
                                                                        </Tooltip> :
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add}</Typography> : '-'}
                                                                </TableCell>
                                                                {props?.isNewOPT ? <TableCell></TableCell> : <TableCell>
                                                                    {item?.BCNVA ? item?.BCNVA?.length > 10 ?
                                                                        <Tooltip placement='top' title={item?.BCNVA}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA?.slice(0, 10) + '...'}</Typography>
                                                                        </Tooltip> :
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA}</Typography> : '-'}
                                                                </TableCell>}
                                                            </TableRow>
                                                        )) : null}
                                                        {docNotes?.pgp?.left_data?.length > 0 ? docNotes?.pgp?.left_data?.map((item, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Left Eye</TableCell>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.SPH ? item?.SPH : '-'}</TableCell>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.CYL ? item?.CYL : '-'}</TableCell>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>
                                                                    {item?.AXIS ? item?.AXIS?.length > 10 ?
                                                                        <Tooltip placement='top' title={item?.AXIS}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS?.slice(0, 10) + '...'}</Typography>
                                                                        </Tooltip> :
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS}</Typography> : '-'}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {item?.BCDVA ? item?.BCDVA?.length > 10 ?
                                                                        <Tooltip placement='top' title={item?.BCDVA}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA?.slice(0, 10) + '...'}</Typography>
                                                                        </Tooltip> :
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA}</Typography> : '-'}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {item?.add ? item?.add?.length > 10 ?
                                                                        <Tooltip placement='top' title={item?.add}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add?.slice(0, 10) + '...'}</Typography>
                                                                        </Tooltip> :
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add}</Typography> : '-'}
                                                                </TableCell>
                                                                {props?.isNewOPT ? <TableCell></TableCell> : <TableCell>
                                                                    {(item?.BCNVA && !props?.isNewOPT) ? item?.BCNVA?.length > 10 ?
                                                                        <Tooltip placement='top' title={item?.BCNVA}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA?.slice(0, 10) + '...'}</Typography>
                                                                        </Tooltip> :
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA}</Typography> : '-'}
                                                                </TableCell>}
                                                            </TableRow>
                                                        )) : null}
                                                    </TableBody>
                                                </Table>
                                                <Box sx={{ display: "flex", margin: "0.5vw" }}>
                                                    <Box sx={{ display: "flex", margin: "0.5vw" }}>
                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>Date : </Typography>
                                                        <Typography fontSize={'0.9vw'} marginLeft={"0.5vw"}>{` ${docNotes?.pgp?.temp_date ? formatDate(docNotes?.pgp?.temp_date) : (docNotes?.pgp?.date ? formatDate(docNotes?.pgp?.date) : "-")}`}</Typography>
                                                    </Box>
                                                    <Box sx={{ display: "flex", margin: "0.5vw" }}>
                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>Frame Type : </Typography>
                                                        <Typography fontSize={'0.9vw'} marginLeft={"0.5vw"}>{` ${docNotes?.pgp?.frameType || "-"}`}</Typography>
                                                    </Box>
                                                    {props?.isNewOPT ? <Box sx={{ display: "flex", margin: "0.5vw" }}>
                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>Lens Type : </Typography>
                                                        <Typography fontSize={'0.9vw'} marginLeft={"0.5vw"}>{` ${docNotes?.pgp?.lens_type || "-"}`}</Typography>
                                                    </Box> : null}
                                                </Box>
                                            </Box>
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === 'subjective_refraction' && item.is_active) {
                            var UserData = JSON.parse(localGetItem("loggedInUserInfo"))
                            return (
                                <TriggerApiOnView id={`subjective_refraction_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`subjective_refraction_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Subjective Refraction</Typography>
                                        <Box sx={{ maxHeight: '15vw', overflow: 'auto', border: '1px solid lightgray' }} component={'div'}>
                                            <Table stickyHeader size='small'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell width={'10.2%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Eye</TableCell>
                                                        {UserData?.new_doctor_notes_template ? null : <TableCell width={'9.09%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>UCVA</TableCell>}
                                                        <TableCell width={'9.08%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>SPH</TableCell>
                                                        <TableCell width={'9.08%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>CYL</TableCell>
                                                        <TableCell width={'9.09%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>AXIS</TableCell>
                                                        <TableCell width={'9.09%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>BCDVA</TableCell>
                                                        {UserData?.new_doctor_notes_template ? null : <TableCell width={'9.09%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>UCNVA</TableCell>}
                                                        <TableCell width={'9.08%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>ADD</TableCell>
                                                        <TableCell width={'9.09%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>BCNVA</TableCell>
                                                        <TableCell width={'9.09%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>PHVA</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {docNotes?.subjective_refraction?.right_data?.length > 0 ? docNotes?.subjective_refraction?.right_data?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Right Eye</TableCell>
                                                            {props?.isNewOPT ?
                                                                (UserData?.new_doctor_notes_template ? null : <TableCell>
                                                                    {item?.UCVA ? item?.UCVA?.length > 10 ?
                                                                        <Tooltip placement='top' title={item?.UCVA}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCVA?.slice(0, 10) + '...'}</Typography>
                                                                        </Tooltip> :
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCVA}</Typography> : '-'}
                                                                </TableCell>) :
                                                                <TableCell>
                                                                    {item?.UC ? item?.UC?.length > 10 ?
                                                                        <Tooltip placement='top' title={item?.UC}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UC?.slice(0, 10) + '...'}</Typography>
                                                                        </Tooltip> :
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UC}</Typography> : '-'}
                                                                </TableCell>}
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.SPH ? item?.SPH : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.CYL ? item?.CYL : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>
                                                                {item?.AXIS ? item?.AXIS?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.AXIS}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.BCDVA ? item?.BCDVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.BCDVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA}</Typography> : '-'}
                                                            </TableCell>
                                                            {UserData?.new_doctor_notes_template ? null : <TableCell>
                                                                {item?.UCNVA ? item?.UCNVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.UCNVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCNVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCNVA}</Typography> : '-'}
                                                            </TableCell>}
                                                            <TableCell>
                                                                {item?.add ? item?.add?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.add}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.BCNVA ? item?.BCNVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.BCNVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.PHVA ? item?.PHVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.PHVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.PHVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.PHVA}</Typography> : '-'}
                                                            </TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                    {docNotes?.subjective_refraction?.left_data?.length > 0 ? docNotes?.subjective_refraction?.left_data?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Left Eye</TableCell>
                                                            {props?.isNewOPT ?
                                                                (UserData?.new_doctor_notes_template ? null : <TableCell>
                                                                    {item?.UCVA ? item?.UCVA?.length > 10 ?
                                                                        <Tooltip placement='top' title={item?.UCVA}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCVA?.slice(0, 10) + '...'}</Typography>
                                                                        </Tooltip> :
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCVA}</Typography> : '-'}
                                                                </TableCell>) :
                                                                <TableCell>
                                                                    {item?.UC ? item?.UC?.length > 10 ?
                                                                        <Tooltip placement='top' title={item?.UC}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UC?.slice(0, 10) + '...'}</Typography>
                                                                        </Tooltip> :
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UC}</Typography> : '-'}
                                                                </TableCell>}
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.SPH ? item?.SPH : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.CYL ? item?.CYL : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>
                                                                {item?.AXIS ? item?.AXIS?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.AXIS}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.BCDVA ? item?.BCDVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.BCDVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA}</Typography> : '-'}
                                                            </TableCell>
                                                           {UserData?.new_doctor_notes_template ? null : <TableCell>
                                                                {item?.UCNVA ? item?.UCNVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.UCNVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCNVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCNVA}</Typography> : '-'}
                                                            </TableCell>}
                                                            <TableCell>
                                                                {item?.add ? item?.add?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.add}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.BCNVA ? item?.BCNVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.BCNVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.PHVA ? item?.PHVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.PHVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.PHVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.PHVA}</Typography> : '-'}
                                                            </TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                </TableBody>
                                            </Table>
                                            {props?.isNewOPT ?
                                                <Box component={'div'}>
                                                    <TextField
                                                        disabled
                                                        size='small'
                                                        multiline
                                                        fullWidth
                                                        maxRows={5}
                                                        value={docNotes?.subjective_refraction?.comments || ""}
                                                        label='Comments'
                                                        inputProps={{ emed_tid: 'rtno_cmts', maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
                                                    />
                                                </Box>
                                                : <Box sx={{ display: 'flex' }}>
                                                    <Box sx={{ display: "flex", margin: "0.5vw" }}>
                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>Occupation : </Typography>
                                                        <Typography fontSize={'0.9vw'} marginLeft={"0.5vw"}>{` ${docNotes?.subjective_refraction?.occupation || "-"}`}</Typography>
                                                    </Box>
                                                    <Box sx={{ display: "flex", margin: "0.5vw" }}>
                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>Chart Used: </Typography>
                                                        <Typography fontSize={'0.9vw'} marginLeft={"0.5vw"}>{` ${docNotes?.subjective_refraction?.chart || "-"}`}</Typography>
                                                    </Box>
                                                    <Box sx={{ display: "flex", margin: "0.5vw" }}>
                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>Muscle : </Typography>
                                                        <Typography fontSize={'0.9vw'} marginLeft={"0.5vw"}>{` ${docNotes?.subjective_refraction?.muscle || "-"}`}</Typography>
                                                    </Box>
                                                </Box>}
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'retinoscopic_refraction' && item.is_active && !props?.isNewOPT) {
                            return (
                                <TriggerApiOnView id={`retinoscopic_refraction_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`retinoscopic_refraction_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Retinoscopic Refraction</Typography>
                                        <Box sx={{ maxHeight: '15vw', overflow: 'auto', border: '1px solid lightgray' }} component={'div'}>
                                            <Table stickyHeader size='small'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Eye</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>UCVA</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>SPH</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>CYL</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>AXIS</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>BCDVA</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>ADD</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>BCNVA</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {docNotes?.retinoscopic_refraction?.left_data?.length > 0 ? docNotes?.retinoscopic_refraction?.left_data?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Left Eye</TableCell>
                                                            <TableCell>
                                                                {item?.UCVA ? item?.UCVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.UCVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.SPH ? item?.SPH : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.CYL ? item?.CYL : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>
                                                                {item?.AXIS ? item?.AXIS?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.AXIS}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.BCDVA ? item?.BCDVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.BCDVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.add ? item?.add?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.add}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.BCNVA ? item?.BCNVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.BCNVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA}</Typography> : '-'}
                                                            </TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                    {docNotes?.retinoscopic_refraction?.right_data?.length > 0 ? docNotes?.retinoscopic_refraction?.right_data?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Right Eye</TableCell>
                                                            <TableCell>
                                                                {item?.UCVA ? item?.UCVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.UCVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.SPH ? item?.SPH : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.CYL ? item?.CYL : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>
                                                                {item?.AXIS ? item?.AXIS?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.AXIS}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.BCDVA ? item?.BCDVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.BCDVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.add ? item?.add?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.add}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.BCNVA ? item?.BCNVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.BCNVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA}</Typography> : '-'}
                                                            </TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                </TableBody>
                                            </Table>
                                            <Box sx={{ display: 'flex' }}>
                                                <Box sx={{ display: "flex", margin: "0.5vw" }}>
                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>Occupation : </Typography>
                                                    <Typography fontSize={'0.9vw'}>{` ${docNotes?.retinoscopic_refraction?.occupation || "-"}`}</Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", margin: "0.5vw" }}>
                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>Chart : </Typography>
                                                    <Typography fontSize={'0.9vw'}>{` ${docNotes?.retinoscopic_refraction?.chart || "-"}`}</Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", margin: "0.5vw" }}>
                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>Muscle : </Typography>
                                                    <Typography fontSize={'0.9vw'}>{` ${docNotes?.retinoscopic_refraction?.muscle || "-"}`}</Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'retinoscopic_refraction' && item.is_active && props?.isNewOPT) {
                            return (
                                <TriggerApiOnView id={`retinoscopic_refraction_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`retinoscopic_refraction_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Retinoscopic Refraction</Typography>
                                        <Box component={'div'} m={'0.5rem'}>
                                            {beforeDilationTable()}
                                            {afterDilationScreen()}
                                            <Box component={'div'}>
                                                <TextField
                                                    disabled
                                                    size='small'
                                                    multiline
                                                    fullWidth
                                                    maxRows={5}
                                                    value={docNotes?.retinoscopic_refraction?.retinoComments}
                                                    label='Comments'
                                                    inputProps={{ emed_tid: 'rtno_cmts', maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
                                                />
                                            </Box>
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === "retinoscopic_acceptance" && item.is_active) {
                            return (
                                <TriggerApiOnView id={`retinoscopic_acceptance_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`retinoscopic_acceptance_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Retinoscopic Acceptance</Typography>
                                        <Box sx={{ maxHeight: '15vw', overflow: 'auto', border: '1px solid lightgray' }} component={'div'}>
                                            <Table stickyHeader size='small'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell width={'10.2%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Eye</TableCell>
                                                        <TableCell width={'9.04%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>UCVA</TableCell>
                                                        <TableCell width={'9.04%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>SPH</TableCell>
                                                        <TableCell width={'9.04%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>CYL</TableCell>
                                                        <TableCell width={'9.04%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>AXIS</TableCell>
                                                        <TableCell width={'9.04%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>BCDVA</TableCell>
                                                        <TableCell width={'9.04%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>UCNVA</TableCell>
                                                        <TableCell width={'9.04%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>ADD</TableCell>
                                                        <TableCell width={'9.04%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>BCNVA</TableCell>
                                                        <TableCell width={'9.04%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>PHVA</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {docNotes?.retinoscopic_acceptance?.left_data?.length > 0 ? docNotes?.retinoscopic_acceptance?.left_data?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Left Eye</TableCell>
                                                            <TableCell>
                                                                {item?.UC ? item?.UC?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.UC}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UC?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UC}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.SPH ? item?.SPH : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.CYL ? item?.CYL : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>
                                                                {item?.AXIS ? item?.AXIS?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.AXIS}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.BCDVA ? item?.BCDVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.BCDVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.UCNVA ? item?.UCNVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.UCNVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCNVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCNVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.add ? item?.add?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.add}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.BCNVA ? item?.BCNVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.BCNVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.PHVA ? item?.PHVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.PHVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.PHVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.PHVA}</Typography> : '-'}
                                                            </TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                    {docNotes?.retinoscopic_acceptance?.right_data?.length > 0 ? docNotes?.retinoscopic_acceptance?.right_data?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Right Eye</TableCell>
                                                            <TableCell>
                                                                {item?.UC ? item?.UC?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.UC}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UC?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UC}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.SPH ? item?.SPH : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.CYL ? item?.CYL : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>
                                                                {item?.AXIS ? item?.AXIS?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.AXIS}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.BCDVA ? item?.BCDVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.BCDVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCDVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.UCNVA ? item?.UCNVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.UCNVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCNVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCNVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.add ? item?.add?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.add}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.BCNVA ? item?.BCNVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.BCNVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.BCNVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.PHVA ? item?.PHVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.PHVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.PHVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.PHVA}</Typography> : '-'}
                                                            </TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                </TableBody>
                                            </Table>
                                            <Box sx={{ display: 'flex' }}>
                                                <Box sx={{ display: "flex", margin: "0.5vw" }}>
                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>Occupation : </Typography>
                                                    <Typography fontSize={'0.9vw'}>{` ${docNotes?.retinoscopic_acceptance?.occupation || "-"}`}</Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", margin: "0.5vw" }}>
                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>Chart : </Typography>
                                                    <Typography fontSize={'0.9vw'}>{` ${docNotes?.retinoscopic_acceptance?.chart || "-"}`}</Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", margin: "0.5vw" }}>
                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>Muscle : </Typography>
                                                    <Typography fontSize={'0.9vw'}>{` ${docNotes?.retinoscopic_acceptance?.muscle || "-"}`}</Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === "vision_assesment" && item.is_active) {
                            return (
                                <TriggerApiOnView id={`vision_assesment_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`vision_assesment_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Vision Assessment</Typography>
                                        <Box sx={{ maxHeight: '25vw', overflow: 'auto', border: '1px solid lightgray' }} component={'div'}>
                                            {props?.isNewOPT ? <Box component={'div'} display={'flex'}>
                                                {renderLables("Chart", (docNotes?.vision_assesment?.chart || ""))}
                                                {renderLables("occupation", (docNotes?.vision_assesment?.occupation || ""))}
                                            </Box> : null}
                                            <Table stickyHeader size='small'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Eye</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>UCVA</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>PH</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>PG/CL</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>NV</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>CV</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {docNotes?.vision_assesment?.right_data?.length > 0 ? docNotes?.vision_assesment?.right_data?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Right Eye</TableCell>
                                                            <TableCell>
                                                                {item?.UCVA ? item?.UCVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.UCVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.PH ? item?.PH : '-'}</TableCell>
                                                            <TableCell>
                                                                {item?.PGCL ? item?.PGCL?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.PGCL}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.PGCL?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.PGCL}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.NV ? item?.NV : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.CV ? item?.CV : '-'}</TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                    {docNotes?.vision_assesment?.left_data?.length > 0 ? docNotes?.vision_assesment?.left_data?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Left Eye</TableCell>
                                                            <TableCell>
                                                                {item?.UCVA ? item?.UCVA?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.UCVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCVA?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.UCVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.PH ? item?.PH : '-'}</TableCell>
                                                            <TableCell>
                                                                {item?.PGCL ? item?.PGCL?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.PGCL}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.PGCL?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.PGCL}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.NV ? item?.NV : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.CV ? item?.CV : '-'}</TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                </TableBody>
                                            </Table>
                                            {props?.isNewOPT ? <Box component={'div'}>
                                                <TextField
                                                    disabled
                                                    size='small'
                                                    multiline
                                                    fullWidth
                                                    maxRows={5}
                                                    value={docNotes?.vision_assesment?.comment}
                                                    label='Comments'
                                                    inputProps={{ emed_tid: 'vsn_cmts', maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
                                                />
                                            </Box> : null}
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === "ocular_response_analyzer" && item.is_active) {
                            return (
                                <TriggerApiOnView id={`ocular_response_analyzer_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`ocular_response_analyzer_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Ocular Response Analyzer</Typography>
                                        <Box sx={{ maxHeight: '17vw', overflow: 'auto', border: '1px solid lightgray' }} component={'div'}>
                                            <Table stickyHeader size='small'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Eye</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>IPOcc</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>CH</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>IPOg</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>WS</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {docNotes?.ocular_response_analyzer?.right_data?.length > 0 ? docNotes?.ocular_response_analyzer?.right_data?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Right Eye</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.ipocc ? item?.ipocc : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.ch ? item?.ch : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.ipog ? item?.ipog : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.ws ? item?.ws : '-'}</TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                    {docNotes?.ocular_response_analyzer?.left_data?.length > 0 ? docNotes?.ocular_response_analyzer?.left_data?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>left Eye</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.ipocc ? item?.ipocc : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.ch ? item?.ch : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.ipog ? item?.ipog : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.ws ? item?.ws : '-'}</TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                </TableBody>
                                            </Table>
                                            {props?.isNewOPT ? <Box component={'div'}>
                                                <TextField
                                                    disabled
                                                    size='small'
                                                    multiline
                                                    fullWidth
                                                    maxRows={5}
                                                    value={docNotes?.ocular_response_analyzer?.comments || ""}
                                                    label='Comments'
                                                    inputProps={{ emed_tid: 'vsn_cmts', maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
                                                />
                                            </Box> : null}
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === "intraocular_pressure" && item.is_active) {
                            return (
                                <TriggerApiOnView id={`intraocular_pressure_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`intraocular_pressure_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Intraocular Pressure</Typography>
                                        <Box sx={{ maxHeight: '17vw', overflow: 'auto' }} component={'div'}>
                                            {docNotes?.intraocular_pressure?.right_data?.length > 0 ? docNotes?.intraocular_pressure?.right_data.map((item) => (
                                                <div>
                                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                        <div>{"Right Eye (RE)"}</div>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", marginTop: "1vw" }}>
                                                        {renderIntraocularTable("NCT", item.NCT, "11vw")}
                                                        {renderIntraocularTable("Applanation Tonometry", item.APPLANATION_TONOMETRY, "16vw")}
                                                        {renderIntraocularTable("CCT (pachymetry)", item.CCT, "13vw")}
                                                        {renderIntraocularTable("CIOP", item.CIOP, "10vw")}
                                                        {renderIntraocularTable("Comments", item.comment, "7vw")}
                                                    </div>
                                                </div>)) :
                                                null}
                                            {docNotes?.intraocular_pressure?.left_data?.length > 0 ? docNotes?.intraocular_pressure?.left_data.map((item) => (
                                                <div style={{ marginTop: "0.5vw" }}>
                                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                        <div>{"Left Eye (LE)"}</div>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", marginTop: "1vw" }}>
                                                        {renderIntraocularTable("NCT", item.NCT, "11vw")}
                                                        {renderIntraocularTable("Applanation Tonometry", item.APPLANATION_TONOMETRY, "16vw")}
                                                        {renderIntraocularTable("CCT (Pachymetry)", item.CCT, "13vw")}
                                                        {renderIntraocularTable("CIOP", item.CIOP, "10vw")}
                                                        {renderIntraocularTable("Comments", item.comment, "7vw")}
                                                    </div>
                                                </div>)) :
                                                null}
                                            {props?.isNewOPT ? <Box component={'div'} style={{ display: "flex", justifyContent: "center", width: '100%', marginTop: "0.5vw" }}>
                                                <TextField
                                                    disabled
                                                    size='small'
                                                    multiline
                                                    fullWidth
                                                    value={docNotes?.intraocular_pressure?.comments ? docNotes?.intraocular_pressure?.comments : "-"}
                                                    label='Comments'
                                                />
                                            </Box> : null}
                                        </Box >
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === "anterior_segment_diagram" && item.is_active) {
                            return (
                                <TriggerApiOnView id={`anterior_segment_diagram_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`anterior_segment_diagram_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Anterior Segment Diagram</Typography>
                                        <Box component={'div'} style={{ display: "flex", justifyContent: "center", width: '100%' }}>
                                            {renderClinicExamImage("anterior_segment_diagram")}
                                        </Box>
                                    </Box>
                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === "auto_refractory" && item.is_active) {
                            return (
                                <TriggerApiOnView id={`auto_refractory_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`auto_refractory_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Auto Refractory</Typography>
                                        <Box sx={{ maxHeight: '15vw', overflow: 'auto', border: '1px solid lightgray', marginTop: "0.5vw" }}>
                                            <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText} margin={"0.3vw"}>Before Dilation</Typography>
                                            <Table stickyHeader size='small'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Eye</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>SPH</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>CYL</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>AXIS</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {docNotes?.auto_refractory?.BeforeDilationRE?.length > 0 ? docNotes?.auto_refractory?.BeforeDilationRE?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Right Eye</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.SPH ? item?.SPH : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.CYL ? item?.CYL : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>
                                                                {item?.AXIS ? item?.AXIS?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.AXIS}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS}</Typography> : '-'}
                                                            </TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                    {docNotes?.auto_refractory?.BeforeDilationLE?.length > 0 ? docNotes?.auto_refractory?.BeforeDilationLE?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Left Eye</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.SPH ? item?.SPH : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.CYL ? item?.CYL : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>
                                                                {item?.AXIS ? item?.AXIS?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.AXIS}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS}</Typography> : '-'}
                                                            </TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                </TableBody>
                                            </Table>
                                        </Box>
                                        <Box sx={{ maxHeight: '15vw', overflow: 'auto', border: '1px solid lightgray', marginTop: "0.5vw" }}>
                                            <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText} margin={"0.3vw"}>After Dilation</Typography>
                                            <Table stickyHeader size='small'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Eye</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>SPH</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>CYL</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>AXIS</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {docNotes?.auto_refractory?.AfterDilationRE?.length > 0 ? docNotes?.auto_refractory?.AfterDilationRE?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Right Eye</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.SPH ? item?.SPH : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.CYL ? item?.CYL : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>
                                                                {item?.AXIS ? item?.AXIS?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.AXIS}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS}</Typography> : '-'}
                                                            </TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                    {docNotes?.auto_refractory?.AfterDilationLE?.length > 0 ? docNotes?.auto_refractory?.AfterDilationLE?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Left Eye</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.SPH ? item?.SPH : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.CYL ? item?.CYL : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>
                                                                {item?.AXIS ? item?.AXIS?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.AXIS}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.AXIS}</Typography> : '-'}
                                                            </TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                </TableBody>
                                            </Table>
                                        </Box>
                                        {props?.isNewOPT ? <Box component={'div'} style={{ display: "flex", justifyContent: "center", width: '100%' }}>
                                            <TextField
                                                disabled
                                                size='small'
                                                multiline
                                                fullWidth
                                                value={docNotes?.auto_refractory?.Comments ? docNotes?.auto_refractory?.Comments : "-"}
                                                label='Comments'
                                            />
                                        </Box> : null}
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === "fundus" && item.is_active) {
                            return (
                                <TriggerApiOnView id={`fundus_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`fundus_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Fundus</Typography>
                                        <Box component={'div'} style={{ display: "flex", justifyContent: "center", width: '100%' }}>
                                            {renderClinicExamImage("fundus")}
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'keratomentry' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`keratomentry_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`keratomentry_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Keratomentry</Typography>
                                        <Box sx={{ maxHeight: '24vw', overflow: 'auto', border: '1px solid lightgray' }} component={'div'}>
                                            {props?.isNewOPT ?
                                                <Table size='small'>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                                            <TableCell className='doc_notes_tbl_header'>K1</TableCell>
                                                            <TableCell className='doc_notes_tbl_header'>K2</TableCell>
                                                            <TableCell className='doc_notes_tbl_header'>Average</TableCell>
                                                            <TableCell className='doc_notes_tbl_header'>Cylindrical</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {docNotes?.keratomentry?.keratomentryData?.length > 0 ? docNotes?.keratomentry?.keratomentryData?.map((item, index) => {
                                                            return (
                                                                <TableRow key={index}>
                                                                    <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.label}</TableCell>
                                                                    <TableCell className='doc_notes_tbl_body_cell'>
                                                                        {autocompleteTextBox('k1_value', item?.k1_value, [], index, item?.label)}
                                                                    </TableCell>
                                                                    <TableCell className='doc_notes_tbl_body_cell'>
                                                                        {autocompleteTextBox('k2_value', item?.k2_value, [], index, item?.label)}
                                                                    </TableCell>
                                                                    <TableCell className='doc_notes_tbl_body_cell'>
                                                                        {autocompleteTextBox('average_value', item?.average_value, [], index, item?.label)}
                                                                    </TableCell>
                                                                    <TableCell className='doc_notes_tbl_body_cell'>
                                                                        {autocompleteTextBox('cylindrical_value', item?.cylindrical_value, [], index, item?.label)}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        }) : <TableRow><TableCell align='center' colSpan={5}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                                                    </TableBody>
                                                </Table> :
                                                <Table stickyHeader size='small'>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Curvature Values</TableCell>
                                                            <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Dioptre</TableCell>
                                                            <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>MM</TableCell>
                                                            <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>AXIS</TableCell></TableRow>
                                                    </TableHead>
                                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText} margin={"0.3vw"}>Left Eye</Typography>
                                                    <TableBody>
                                                        {docNotes?.keratomentry?.left_data?.length > 0 ? docNotes?.keratomentry?.left_data?.map((item, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.curvature ? item?.curvature : '-'}</TableCell>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.dioptre ? item?.dioptre : '-'}</TableCell>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.mm ? item?.mm : '-'}</TableCell>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>
                                                                    {item?.axis ? item?.axis?.length > 10 ?
                                                                        <Tooltip placement='top' title={item?.axis}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.axis?.slice(0, 10) + '...'}</Typography>
                                                                        </Tooltip> :
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.axis}</Typography> : '-'}
                                                                </TableCell>
                                                            </TableRow>
                                                        )) : null}
                                                        <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText} margin={"0.3vw"}>Right Eye</Typography>
                                                        {docNotes?.keratomentry?.right_data?.length > 0 ? docNotes?.keratomentry?.right_data?.map((item, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.curvature ? item?.curvature : '-'}</TableCell>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.dioptre ? item?.dioptre : '-'}</TableCell>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.mm ? item?.mm : '-'}</TableCell>
                                                                <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>
                                                                    {item?.axis ? item?.axis?.length > 10 ?
                                                                        <Tooltip placement='top' title={item?.axis}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.axis?.slice(0, 10) + '...'}</Typography>
                                                                        </Tooltip> :
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.axis}</Typography> : '-'}
                                                                </TableCell>
                                                            </TableRow>
                                                        )) : null}
                                                    </TableBody>
                                                </Table>}
                                            {props?.isNewOPT ? <Box component={'div'} style={{ display: "flex", justifyContent: "center", width: '100%' }}>
                                                <TextField
                                                    disabled
                                                    size='small'
                                                    multiline
                                                    fullWidth
                                                    value={docNotes?.keratomentry?.keratoComments ? docNotes?.keratomentry?.keratoComments : "-"}
                                                    label='Comments'
                                                />
                                            </Box> : null}
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === "anterior_segment" && item.is_active) {
                            return (
                                <TriggerApiOnView id={`anterior_segment_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`anterior_segment_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Anterior Segment</Typography>
                                        <Box width={"50vw"} marginLeft={"3vw"}>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
                                                {<Typography fontWeight={600} flex={0.2}></Typography>}
                                                <Typography fontWeight={600} flex={0.4} paddingLeft={"7vw"}>Right Eye</Typography>
                                                <Typography fontWeight={600} flex={0.4} paddingLeft={"7vw"}>Left Eye</Typography>
                                            </Box>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                {<Typography fontWeight={600} flex={0.3}>Lids</Typography>}
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("LidsRightEye", docNotes?.anterior_segment.LidsRightEye)}</Box>
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("LidsLeftEye", docNotes?.anterior_segment.LidsLeftEye)}</Box>
                                            </Box>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                {<Typography fontWeight={600} flex={0.3}>Extra Ocular Movement</Typography>}
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("ExtraocularRightEye", docNotes?.anterior_segment.ExtraocularRightEye)}</Box>
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("ExtraocularLeftEye", docNotes?.anterior_segment.ExtraocularLeftEye)}</Box>
                                            </Box>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                {<Typography fontWeight={600} flex={0.3}>Conjunctiva</Typography>}
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("ConjunctivaRightEye", docNotes?.anterior_segment.ConjunctivaRightEye)}</Box>
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("ConjunctivaLeftEye", docNotes?.anterior_segment.ConjunctivaLeftEye)}</Box>
                                            </Box>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                {<Typography fontWeight={600} flex={0.3}>Sclera</Typography>}
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("ScleraRightEye", docNotes?.anterior_segment.ScleraRightEye)}</Box>
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("ScleraLeftEye", docNotes?.anterior_segment.ScleraLeftEye)}</Box>
                                            </Box>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                {<Typography fontWeight={600} flex={0.3}>Cornea</Typography>}
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("CorneaRightEye", docNotes?.anterior_segment.CorneaRightEye)}</Box>
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("CorneaLeftEye", docNotes?.anterior_segment.CorneaLeftEye)}</Box>
                                            </Box>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                {<Typography fontWeight={600} flex={0.3}>Anterior Chamber</Typography>}
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("AnteriorChambRightEye", docNotes?.anterior_segment.AnteriorChambRightEye)}</Box>
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("AnteriorChambLeftEye", docNotes?.anterior_segment.AnteriorChambLeftEye)}</Box>
                                            </Box>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                {<Typography fontWeight={600} flex={0.3}>Pupil</Typography>}
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("PupilRightEye", docNotes?.anterior_segment.PupilRightEye)}</Box>
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("PupilLeftEye", docNotes?.anterior_segment.PupilLeftEye)}</Box>
                                            </Box>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                {<Typography fontWeight={600} flex={0.3}>Iris</Typography>}
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("IrisRightEye", docNotes?.anterior_segment.IrisRightEye)}</Box>
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("IrisLeftEye", docNotes?.anterior_segment.IrisLeftEye)}</Box>
                                            </Box>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                {<Typography fontWeight={600} flex={0.3}>Lens</Typography>}
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("LensRightEye", docNotes?.anterior_segment.LensRightEye)}</Box>
                                                <Box flex={0.4}>{renderTextBox_anterior_segment("LensLeftEye", docNotes?.anterior_segment.LensLeftEye)}</Box>
                                            </Box>
                                        </Box>
                                        {props?.isNewOPT ? <Box component={'div'} style={{ display: "flex", justifyContent: "center", width: '100%' }}>
                                            <TextField
                                                disabled
                                                size='small'
                                                multiline
                                                fullWidth
                                                value={docNotes?.anterior_segment?.anteriorComments ? docNotes?.anterior_segment?.anteriorComments : "-"}
                                                label='Comments'
                                            />
                                        </Box> : null}
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'IOLMaster' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`IOLMaster_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`IOLMaster_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>IOL Master</Typography>
                                        <Box sx={{ maxHeight: '40vw', overflow: 'auto', border: '1px solid lightgray' }} component={'div'}>
                                            <Table stickyHeader size='small'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ backgroundColor: Colors.Background, fontWeight: 600, fontSize: '0.9vw' }}>Curvature Value</TableCell>
                                                        <TableCell sx={{ backgroundColor: Colors.Background, fontWeight: 600, fontSize: '0.9vw' }}>Right Eye (OD)</TableCell>
                                                        <TableCell sx={{ backgroundColor: Colors.Background, fontWeight: 600, fontSize: '0.9vw' }}>Left Eye (OS)</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {docNotes?.IOLMaster?.map((item, index) => {
                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell>
                                                                    <Typography fontWeight={600} fontSize={'0.9vw'}>{item?.label ? item?.label : '-'}</Typography>
                                                                </TableCell>
                                                                <TableCell>
                                                                    {inputIoLTextBox('re_eye', item?.re_eye, index, item?.label, true)}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {inputIoLTextBox('le_eye', item?.le_eye, index, item?.label, true)}
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                                </TableBody>
                                            </Table>
                                            {props?.isNewOPT ? <Box component={'div'} style={{ display: "flex", justifyContent: "center", width: '100%' }}>
                                                <TextField
                                                    disabled
                                                    size='small'
                                                    multiline
                                                    fullWidth
                                                    value={docNotes?.iolComments ? docNotes?.iolComments : "-"}
                                                    label='Comments'
                                                />
                                            </Box> : null}
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === "posterior_segment" && item.is_active) {
                            return (
                                <TriggerApiOnView id={`posterior_segment_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`posterior_segment_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}> Posterior Segment </Typography>
                                        <Box width={"50vw"} marginLeft={"1.5vw"}>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
                                                <Typography fontWeight={600} flex={0.2}></Typography>
                                                <Typography fontWeight={600} flex={0.4} paddingLeft={"7vw"}>Right Eye</Typography>
                                                <Typography fontWeight={600} flex={0.4} paddingLeft={"7vw"}>Left Eye</Typography>
                                            </Box>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                <Typography fontWeight={600} flex={0.2}>Disc</Typography>
                                                <Box flex={0.4}>{renderTextBox_posterior_segment("discRightEye")}</Box>
                                                <Box flex={0.4}>{renderTextBox_posterior_segment("discLeftEye")}</Box>
                                            </Box>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                <Typography fontWeight={600} flex={0.2}>Macula</Typography>
                                                <Box flex={0.4}>{renderTextBox_posterior_segment("maculaRightEye")}</Box>
                                                <Box flex={0.4}>{renderTextBox_posterior_segment("maculaLeftEye")}</Box>
                                            </Box>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                <Typography fontWeight={600} flex={0.2}>Media</Typography>
                                                <Box flex={0.4}>{renderTextBox_posterior_segment("mediaRightEye")}</Box>
                                                <Box flex={0.4}>{renderTextBox_posterior_segment("mediaLeftEye")}</Box>
                                            </Box>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                <Typography fontWeight={600} flex={0.2}>Vessels</Typography>
                                                <Box flex={0.4}>{renderTextBox_posterior_segment("vesselsRightEye")}</Box>
                                                <Box flex={0.4}>{renderTextBox_posterior_segment("vesselsLeftEye")}</Box>
                                            </Box>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                <Typography fontWeight={600} flex={0.2}>Periphery</Typography>
                                                <Box flex={0.4}>{renderTextBox_posterior_segment("peripheryRightEye")}</Box>
                                                <Box flex={0.4}>{renderTextBox_posterior_segment("peripheryLeftEye")}</Box>
                                            </Box>
                                        </Box>
                                        {props?.isNewOPT ? <Box component={'div'} style={{ display: "flex", justifyContent: "center", width: '100%' }}>
                                            <TextField
                                                disabled
                                                size='small'
                                                multiline
                                                fullWidth
                                                value={docNotes?.posterior_segment?.posteriorComments ? docNotes?.posterior_segment?.posteriorComments : "-"}
                                                label='Comments'
                                            />
                                        </Box> : null}
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === "other_investigation" && item.is_active) {
                            return (
                                <TriggerApiOnView id={`other_investigation_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`other_investigation_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Other Investigation</Typography>
                                        <Box width={"50vw"} marginLeft={"1.5vw"}>
                                            <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
                                                <Typography fontWeight={600} flex={0.2}></Typography>
                                                <Typography fontWeight={600} flex={0.4} paddingLeft={"7vw"}>Right Eye</Typography>
                                                <Typography fontWeight={600} flex={0.4} paddingLeft={"7vw"}>Left Eye</Typography>
                                            </Box>
                                            {other_investigation['WFDT']?.is_checked ?
                                                <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                    <Typography fontWeight={600} flex={0.2}>WFDT</Typography>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("WFDTRightEye", docNotes?.other_investigation?.WFDTSuggRE)}</Box>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("WFDTLeftEye", docNotes?.other_investigation?.WFDTSuggLE)}</Box>
                                                </Box> : null}
                                            {other_investigation['EOM']?.is_checked ?
                                                <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                    <Typography fontWeight={600} flex={0.2}>EOM</Typography>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("EOMRightEye", docNotes?.other_investigation?.EOMSuggRE)}</Box>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("EOMLeftEye", docNotes?.other_investigation?.EOMSuggLE)}</Box>
                                                </Box> : null}
                                            {other_investigation['Color Vision']?.is_checked ?
                                                <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                    <Typography fontWeight={600} flex={0.2}>Color Vision</Typography>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("ColorVisionRightEye", docNotes?.other_investigation?.ColorVisionSuggRE)}</Box>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("ColorVisionLeftEye", docNotes?.other_investigation?.ColorVisionSuggLE)}</Box>
                                                </Box> : null}
                                            {other_investigation['Confrontation']?.is_checked ?
                                                <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                    <Typography fontWeight={600} flex={0.2}>Confrontation</Typography>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("ConfrontationRightEye", docNotes?.other_investigation?.ConfrontationSuggRE)}</Box>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("ConfrontationLeftEye", docNotes?.other_investigation?.ConfrontationSuggLE)}</Box>
                                                </Box> : null}
                                            {other_investigation['Pupil']?.is_checked ?
                                                <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                    <Typography fontWeight={600} flex={0.2}>Pupil</Typography>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("PupilRightEye", docNotes?.other_investigation?.PupilSuggRE)}</Box>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("PupilLeftEye", docNotes?.other_investigation?.PupilSuggLE)}</Box>
                                                </Box> : null}
                                            {other_investigation['Pachymetry']?.is_checked ?
                                                <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                    <Typography fontWeight={600} flex={0.2}>Pachymetry</Typography>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("PachymentryRightEye", docNotes?.other_investigation?.PachymentrySuggRE)}</Box>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("PachymentryLeftEye", docNotes?.other_investigation?.PachymentrySuggLE)}</Box>
                                                </Box> : null}
                                            {other_investigation[`Schirmer's Test`]?.is_checked ?
                                                <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                    <Typography fontWeight={600} flex={0.2}>Schirmer's Test</Typography>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("SchirmerRightEye", docNotes?.other_investigation?.SchirmerSuggRE)}</Box>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("SchirmerLeftEye", docNotes?.other_investigation?.SchirmerSuggLE)}</Box>
                                                </Box> : null}
                                            {other_investigation['Contrast Sensitivity']?.is_checked ?
                                                <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                    <Typography fontWeight={600} flex={0.2}>Contrast Sensitivity</Typography>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("ContrastRightEye", docNotes?.other_investigation?.ContrastSuggRE)}</Box>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("ContrastLeftEye", docNotes?.other_investigation?.ContrastSuggLE)}</Box>
                                                </Box> : null}
                                            {other_investigation['Syringe']?.is_checked ?
                                                <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                    <Typography fontWeight={600} flex={0.2}>Syringe</Typography>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("SyringeRightEye", docNotes?.other_investigation?.SyringeRE)}</Box>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("SyringeLeftEye", docNotes?.other_investigation?.SyringeLE)}</Box>
                                                </Box> : null}
                                            {other_investigation['Additional Details']?.is_checked ?
                                                <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                    <Typography fontWeight={600} flex={0.2}>Additional Details</Typography>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("AdditionalRightEye", docNotes?.other_investigation?.AdditionalRE)}</Box>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation("AdditionalLeftEye", docNotes?.other_investigation?.AdditionalLE)}</Box>
                                                </Box> : null}
                                            {other_investigation['Duct']?.is_checked ?
                                                <Box width={"100%"} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={"center"} marginY={"0.5vw"}>
                                                    <Typography fontWeight={600} flex={0.2}>Duct</Typography>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation('DuctRightEye', docNotes?.other_investigation?.DuctRE)}</Box>
                                                    <Box flex={0.4}>{renderTextBox_other_investigation('DuctLeftEye', docNotes?.other_investigation?.DuctLE)}</Box>
                                                </Box> : null}
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'gonioscopy' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`gonioscopy_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`gonioscopy_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Gonioscopy</Typography>
                                        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-around'}>
                                            {renderGonioscopyImage("Right Eye (OD) - Before Dilation", docNotes?.gonioscopy?.B_R_Inferior, docNotes?.gonioscopy?.B_R_Nasal, docNotes?.gonioscopy?.B_R_Superior, docNotes?.gonioscopy?.B_R_Temporal)}
                                            {renderGonioscopyImage("Left Eye (OS) - Before Dilation", docNotes?.gonioscopy?.B_L_Inferior, docNotes?.gonioscopy?.B_L_Nasal, docNotes?.gonioscopy?.B_L_Superior, docNotes?.gonioscopy?.B_L_Temporal)}
                                        </Box>
                                        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-around'}>
                                            {renderGonioscopyImage("Right Eye (OD) - After Dilation", docNotes?.gonioscopy?.A_R_Inferior, docNotes?.gonioscopy?.A_R_Nasal, docNotes?.gonioscopy?.A_R_Superior, docNotes?.gonioscopy?.A_R_Temporal)}
                                            {renderGonioscopyImage("Left Eye (OS) - After Dilation", docNotes?.gonioscopy?.A_L_Inferior, docNotes?.gonioscopy?.A_L_Nasal, docNotes?.gonioscopy?.A_L_Superior, docNotes?.gonioscopy?.A_L_Temporal)}
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'treatment_plan' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`treatment_plan_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`treatment_plan_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Treatment Plan</Typography>
                                        <div>
                                            <br></br>
                                            <TextField
                                                multiline
                                                label='Description Here'
                                                disabled
                                                rows={6}
                                                sx={{ width: '100%', height: "100%" }}
                                                value={docNotes?.treatment_plan}
                                            />
                                        </div>
                                    </Box>
                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'diagnosis' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`diagnosis_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`diagnosis_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Diagnosis</Typography>
                                        <Table stickyHeader size='small'>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell width={'25%'} sx={{ backgroundColor: Colors.Background, color: Colors.SecondaryText, fontWeight: '600', fontSize: '0.9vw' }}>ICD Code</TableCell>
                                                    <TableCell width={'32%'} sx={{ backgroundColor: Colors.Background, color: Colors.SecondaryText, fontWeight: '600', fontSize: '0.9vw' }}>Short Description</TableCell>
                                                    <TableCell width={'32%'} sx={{ backgroundColor: Colors.Background, color: Colors.SecondaryText, fontWeight: '600', fontSize: '0.9vw' }}>Long Description</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    docNotes?.diagonis?.diagonisDataList?.length > 0 ? docNotes?.diagonis?.diagonisDataList?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw' }}>{item?.icd_code ? item?.icd_code : '-'}</TableCell>
                                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw' }}>{item?.short_desc ? item?.short_desc?.length > 30 ?
                                                                <Tooltip placement='top' title={item?.short_desc}><div style={{ fontSize: '0.9vw', fontWeight: 600 }}>{item?.short_desc?.slice(0, 30) + '...'}</div></Tooltip> :
                                                                item?.short_desc : '-'}</TableCell>
                                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.9vw' }}>{item?.desc ? item?.desc?.length > 30 ?
                                                                <Tooltip placement='top' title={item?.desc}><div style={{ fontSize: '0.9vw', fontWeight: 600 }}>{item?.desc?.slice(0, 30) + '...'}</div></Tooltip> :
                                                                item?.desc
                                                                : '-'}</TableCell>
                                                        </TableRow>
                                                    )) :
                                                        <TableRow>
                                                            <TableCell />
                                                            <TableCell align='center'>No Records To be Shown</TableCell>
                                                            <TableCell />
                                                            <TableCell />
                                                        </TableRow>
                                                }
                                            </TableBody>
                                        </Table>
                                        <Autocomplete
                                            freeSolo
                                            disabled
                                            readOnly
                                            size="small"
                                            sx={{ margin: '0.5vw' }}
                                            options={docNotes?.diagonis?.provDiagnosisSuggestion}
                                            getOptionLabel={(option) => (typeof option === "string" ? option : option?.provisional_diagnosis)}
                                            value={docNotes?.diagonis?.provisional_diagnosis ? docNotes?.diagonis?.provisional_diagnosis : ''}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    multiline
                                                    label={"Provisional Diagnosis"}
                                                    placeholder={"Provisional Diagnosis (Max 250 Characters)"}
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        maxLength: 250,
                                                        emed_tid: 'prov_diagnosis_dropDown_testID'
                                                    }}
                                                />
                                            )}
                                        />
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'notes' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`notes_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`notes_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Notes</Typography>
                                        <div style={{ height: "10vw", width: "95%", paddingLeft: "1vw" }}>
                                            <TextField
                                                label={("Write Your Advice Here")}
                                                style={{ height: "8vw", marginTop: "0.75vw", width: "100%" }}
                                                multiline={true}
                                                rows={4}
                                                variant="outlined"
                                                value={docNotes?.notes}
                                                disabled
                                            />
                                        </div>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'optometry_notes' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`optometry_notes_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`optometry_notes_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Optometrist Notes</Typography>
                                        <div style={{ height: "5vw", width: "95%", paddingLeft: "1vw" }} >
                                            <TextField
                                                label={("Optometrist Notes")}
                                                style={{ height: "8vw", marginTop: "0.75vw", width: "100%" }}
                                                multiline
                                                fullWidth
                                                maxRows={3}
                                                disabled
                                                value={docNotes?.optometry_notes}
                                            />
                                        </div>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'oct_findings' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`oct_findings_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`oct_findings_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>OCT Findings</Typography>
                                        <div style={{ height: "10vw", width: "95%", paddingLeft: "1vw" }} >
                                            <TextField
                                                label={("OCT Findings")}
                                                style={{ height: "8vw", marginTop: "0.75vw", width: "100%" }}
                                                multiline={true}
                                                rows={4}
                                                variant="outlined"
                                                disabled
                                                value={docNotes?.oct_findings}
                                            />
                                        </div>
                                    </Box>
                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'prescription' && item.is_active) {
                            const txtStyle = { fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }
                            return (
                                <TriggerApiOnView id={`prescription_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`prescription_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Medication</Typography>
                                        <div style={{ height: "16vw", width: "95%", paddingLeft: "1vw" }} >
                                            <Box component={'div'} border={'1px solid lightgray'} maxHeight={'15vw'} overflow={'auto'}>
                                                <Table stickyHeader size='small' >
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell width={'25%'} sx={txtStyle}>Drug Name</TableCell>
                                                            <TableCell width={'24%'} sx={txtStyle}>Frequency</TableCell>
                                                            <TableCell width={'20%'} sx={txtStyle}>Duration/Unit</TableCell>
                                                            <TableCell width={'13%'} sx={txtStyle}>Quantity</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {docNotes?.prescription?.length > 0 ? docNotes?.prescription[0]?.prescription_lines?.map((item, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell>
                                                                    {item?.brand_name ? (
                                                                        <Box component={'div'}>
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>
                                                                                <Tooltip placement='top' title={item?.brand_name}>
                                                                                    <div>
                                                                                        {item?.brand_name.length > 15
                                                                                            ? `${item?.brand_name.slice(0, 15)}... `
                                                                                            : item?.brand_name}
                                                                                    </div>
                                                                                </Tooltip>
                                                                            </Typography>
                                                                            {item?.generic_name && (
                                                                                <Typography fontSize={'0.8vw'} color={Colors.SecondaryText}>
                                                                                    {`${typeof item.generic_name === 'object'
                                                                                        ? JSON.stringify(item.generic_name)
                                                                                        : item?.generic_name?.length > 15
                                                                                            ? `${item?.generic_name.slice(0, 15)}...`
                                                                                            : item?.generic_name} | ${item?.dosage_type ? item?.dosage_type : ''}`}
                                                                                </Typography>
                                                                            )}
                                                                        </Box>
                                                                    ) : '-'}
                                                                </TableCell>
                                                                <TableCell>{
                                                                    item?.tapper_meds?.length > 0 ? (
                                                                        item?.tapper_meds?.map((list, listIndex) => (
                                                                            <Box key={listIndex} component={'div'}>
                                                                                <Typography fontSize={'0.9vw'} fontWeight={600}>{list?.no_of_dosage ? list?.no_of_dosage : "-"}</Typography>
                                                                                <Typography fontSize={'0.8vw'} color={Colors.SecondaryText}>{`${list?.frequency ? list?.frequency : "-"}`}</Typography>
                                                                            </Box>
                                                                        ))) : <div style={{ fontWeight: "600" }}>{item?.frequency ? item?.frequency : "-"}</div>
                                                                }</TableCell>
                                                                <TableCell>
                                                                    {
                                                                        item?.tapper_meds?.length > 0 ? (
                                                                            item?.tapper_meds?.map((list, listIndex) => (
                                                                                <Box key={listIndex} component={'div'}>
                                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{list?.duration}</Typography>
                                                                                    <Typography fontSize={'0.8vw'} color={Colors.SecondaryText}>{`${list?.start_date ? (list?.start_date).split("-").reverse().join("-") : "-"} | ${list?.end_date ? (list?.end_date).split("-").reverse().join("-") : '-'}`}</Typography>
                                                                                </Box>
                                                                            ))) : <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.duration ? (item?.duration.split(" ")[1] === "Until_the_Next_Visit") ? "Until the Next Visit" : item?.duration : "-"}</Typography>
                                                                    }
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.quantity ? item?.quantity : 0}</Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        )) :
                                                            <TableRow>
                                                                <TableCell colSpan={5} align="center" sx={{ position: 'relative' }}>
                                                                    No Records To Be Shown
                                                                </TableCell>
                                                            </TableRow>
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </Box>
                                        </div>
                                    </Box>
                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'Patient Category' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`Patient Category_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`Patient Category_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Patient Category</Typography>
                                        <Box component={'div'} display={'flex'} flexWrap={'wrap'} sx={{ backgroundColor: Colors.white }} padding={"0.5vw 0.5vw 0.5vw 0.5vw"}>
                                            {docNotes?.Patient_Category?.length > 0 && docNotes?.Patient_Category?.map((item, index) => (
                                                <Chip
                                                    className='eMed_chip eMed_Chip_Border'
                                                    size="small"
                                                    label={item.category}
                                                    key={index}
                                                    variant='outlined'
                                                    disabled
                                                />
                                            ))}
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'complaints' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`complaints_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`complaints_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Complaints</Typography>
                                        <Box component={'div'} sx={{ border: '1px solid lightgray', maxHeight: '20vw', overflow: 'auto' }}>
                                            <Box component={'div'} style={{ display: "flex", flexDirection: "column", paddingLeft: "0.5vw", marginTop: "0.5vw" }}>
                                                {props?.isNewOPT ? <Box component={'div'} style={{ marginLeft: "0.5vw" }}>
                                                    {renderLables("Complaints Description", docNotes?.complainDescrp ? docNotes?.complainDescrp : "-")}
                                                </Box> : null}
                                            </Box>
                                            <Table stickyHeader size='small'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Eye</Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Complaints</Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Duration</Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        docNotes?.complaints?.length > 0 ? docNotes?.complaints?.map((item, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell>
                                                                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                                                                        <Typography fontSize={'0.8vw'} fontWeight={600}>{item?.complaints == 1 ? "Right" : item?.complaints == 2 ? "Left" : item?.complaints == 3 ? "Both" : "-"}</Typography>
                                                                    </Box>
                                                                </TableCell>
                                                                <TableCell>
                                                                    {item?.complaint_description ?
                                                                        item?.complaint_description?.length > 40 ?
                                                                            <Tooltip placement='top' title={item?.complaint_description}>
                                                                                <Typography fontSize={'0.8vw'} fontWeight={600} mr={'0.5vw'}>{item?.complaint_description?.slice(0, 40) + '...'}</Typography>
                                                                            </Tooltip> :
                                                                            <Typography fontSize={'0.8vw'} fontWeight={600} mr={'0.5vw'}>{item?.complaint_description}</Typography> : '-'
                                                                    }
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                                                                        {item?.duration_time ?
                                                                            item?.duration_time?.length > 10 ?
                                                                                <Tooltip placement='top' title={item?.duration_time}>
                                                                                    <Typography fontSize={'0.8vw'} fontWeight={600} mr={'0.5vw'}>{item?.duration_time?.slice(0, 10) + '...'}</Typography>
                                                                                </Tooltip> :
                                                                                <Typography fontSize={'0.8vw'} fontWeight={600} mr={'0.5vw'}>{item?.duration_time + " " + (item?.duration_type == 1 ? "Days" : item?.duration_type == 2 ? "Weeks" : item?.duration_type == 3 ? "Months" : "Years")}</Typography> : '-'
                                                                        }
                                                                        {item?.comments ? <Tooltip placement='top' title={item?.comments}><DescriptionIcon color='primary' /></Tooltip> : null}
                                                                    </Box>
                                                                </TableCell>
                                                            </TableRow>
                                                        )) : <TableRow>
                                                            <TableCell />
                                                            <TableCell align='center'>No Records To Be Shown</TableCell>
                                                            <TableCell />
                                                        </TableRow>}
                                                </TableBody>
                                            </Table>
                                        </Box>
                                    </Box>
                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'ocular_history' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`ocular_history_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`ocular_history_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Ocular History</Typography>
                                        <Box component={'div'} sx={{ backgroundColor: Colors.white }} pt={'0.5vw'}>
                                            <Box component={'div'} sx={{ border: '1px solid lightgray', }}>
                                                <Typography fontWeight={'bold'} fontSize={'1vw'} margin={"0.5vw"}>Medication</Typography>
                                                <Table stickyHeader size='small'  >
                                                    <TableHead>
                                                        <TableRow >
                                                            <TableCell sx={{ backgroundColor: Colors.Background, width: '50%' }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Medication</Typography>
                                                            </TableCell>
                                                            <TableCell sx={{ backgroundColor: Colors.Background, width: '50%' }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Comments</Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            docNotes?.ocular_history?.MedicationData?.length > 0 ? docNotes?.ocular_history?.MedicationData?.map((item, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell style={{ fontWeight: 600 }}>
                                                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start" }}>
                                                                            <div style={{ fontSize: "0.9vw" }}>{item?.drug_name}</div>
                                                                            {!props?.isNewOPT ?
                                                                                <div style={{ fontSize: "0.8vw" }}>{(item.years || item?.months || item.days) ? `${item?.years ? item.years : "0"}Y ${item?.months ? item?.months : "0"}M ${item.days ? item.days : "0"}D` : "-"}</div>
                                                                                : null}
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {item?.comments ? item?.comments?.length > 15 ?
                                                                            <Tooltip placement='top' title={item?.comments}>
                                                                                <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.comments?.slice(0, 15) + '...'}</Typography>
                                                                            </Tooltip> :
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.comments}</Typography> : '-'}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )) : <TableRow>
                                                                <TableCell />
                                                                <TableCell>No Records To Be Shown</TableCell>
                                                                <TableCell />
                                                            </TableRow>}
                                                    </TableBody>
                                                </Table>
                                            </Box>
                                            <Box component={'div'} sx={{ border: '1px solid lightgray', marginTop: "0.75vw" }}>
                                                <Typography fontWeight={'bold'} fontSize={'1vw'} margin={"0.5vw"}>Surgery</Typography>
                                                <Table stickyHeader size='small'>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Eye</Typography>
                                                            </TableCell>
                                                            <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Surgery</Typography>
                                                            </TableCell>
                                                            <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Comments</Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            docNotes?.ocular_history?.SurgeryData?.length > 0 ? docNotes?.ocular_history?.SurgeryData?.map((item, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell>
                                                                        <Typography fontSize={'0.8vw'} fontWeight={600}>{item?.eye_type === "Right Eye (OD)" ? "Right" : item?.eye_type === "Left Eye (OS)" ? "Left" : (item?.eye_type === "Both Eye (OU)" || item?.eye_type === "Both (OU)") ? "Both" : "-"}</Typography>
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: 600 }}>
                                                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start" }}>
                                                                            <div style={{ fontSize: "0.9vw" }}>{item?.surgery_name}</div>
                                                                            {!props?.isNewOPT ?
                                                                                <div style={{ fontSize: "0.8vw" }}>{item?.no_of_years ? `${item?.no_of_years ? item.no_of_years : "0"}Y` : "-"}</div>
                                                                                : null}
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {item?.reason ? item?.reason?.length > 15 ?
                                                                            <Tooltip placement='top' title={item?.reason}>
                                                                                <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.reason?.slice(0, 15) + '...'}</Typography>
                                                                            </Tooltip> :
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.reason}</Typography> : '-'}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )) : <TableRow>
                                                                <TableCell />
                                                                <TableCell>No Records To Be Shown</TableCell>
                                                                <TableCell />
                                                            </TableRow>}
                                                    </TableBody>
                                                </Table>
                                            </Box>
                                            {UserData?.new_doctor_notes_template ?
                                                <>
                                                <Box component={'div'} sx={{ border: '1px solid lightgray', marginTop: "0.75vw" }}>
                                                <Typography fontWeight={'bold'} fontSize={'1vw'} margin={"0.5vw"}>Contact Lense</Typography>
                                                <Table stickyHeader size='small'>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Eye</Typography>
                                                            </TableCell>
                                                            <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Contact Lense</Typography>
                                                            </TableCell>
                                                            <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Comments</Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            docNotes?.ocular_history?.ContactLensData?.length > 0 ? docNotes?.ocular_history?.ContactLensData?.map((item, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell>
                                                                        <Typography fontSize={'0.8vw'} fontWeight={600}>{item?.eye_type === "Right Eye (OD)" ? "Right" : item?.eye_type === "Left Eye (OS)" ? "Left" : (item?.eye_type === "Both Eye (OU)" || item?.eye_type === "Both (OU)") ? "Both" : "-"}</Typography>
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: 600 }}>
                                                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start" }}>
                                                                            <div style={{ fontSize: "0.9vw" }}>{item?.lense_name}</div>
                                                                            {!props?.isNewOPT ?
                                                                                <div style={{ fontSize: "0.8vw" }}>{item?.no_of_years ? `${item?.no_of_years ? item.no_of_years : "0"}Y` : "-"}</div>
                                                                                : null}
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {item?.reason ? item?.reason?.length > 15 ?
                                                                            <Tooltip placement='top' title={item?.reason}>
                                                                                <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.reason?.slice(0, 15) + '...'}</Typography>
                                                                            </Tooltip> :
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.reason}</Typography> : '-'}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )) : <TableRow>
                                                                <TableCell />
                                                                <TableCell>No Records To Be Shown</TableCell>
                                                                <TableCell />
                                                            </TableRow>}
                                                    </TableBody>
                                                </Table>
                                            </Box>
                                            <Box component={'div'} sx={{ border: '1px solid lightgray', marginTop: "0.75vw" }}>
                                                <Typography fontWeight={'bold'} fontSize={'1vw'} margin={"0.5vw"}>Others</Typography>
                                                <Table stickyHeader size='small'>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Eye</Typography>
                                                            </TableCell>
                                                            <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Others</Typography>
                                                            </TableCell>
                                                            <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Comments</Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            docNotes?.ocular_history?.OthersData?.length > 0 ? docNotes?.ocular_history?.OthersData?.map((item, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell>
                                                                        <Typography fontSize={'0.8vw'} fontWeight={600}>{item?.eye_type === "Right Eye (OD)" ? "Right" : item?.eye_type === "Left Eye (OS)" ? "Left" : (item?.eye_type === "Both Eye (OU)" || item?.eye_type === "Both (OU)") ? "Both" : "-"}</Typography>
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: 600 }}>
                                                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start" }}>
                                                                            <div style={{ fontSize: "0.9vw" }}>{item?.lense_name}</div>
                                                                            {!props?.isNewOPT ?
                                                                                <div style={{ fontSize: "0.8vw" }}>{item?.no_of_years ? `${item?.no_of_years ? item.no_of_years : "0"}Y` : "-"}</div>
                                                                                : null}
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {item?.reason ? item?.reason?.length > 15 ?
                                                                            <Tooltip placement='top' title={item?.reason}>
                                                                                <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.reason?.slice(0, 15) + '...'}</Typography>
                                                                            </Tooltip> :
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.reason}</Typography> : '-'}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )) : <TableRow>
                                                                <TableCell />
                                                                <TableCell>No Records To Be Shown</TableCell>
                                                                <TableCell />
                                                            </TableRow>}
                                                    </TableBody>
                                                </Table>
                                            </Box>
                                                </> : null }
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'systemic_illness' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`systemic_illness_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`systemic_illness_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Systemic Illness</Typography>
                                        <Box component={'div'} sx={{ backgroundColor: Colors.white }} pt={'0.5vw'}>
                                            <Typography fontWeight={'bold'} fontSize={'1vw'} margin={"0.5vw"}>Illness</Typography>
                                            <Box component={'div'} sx={{ border: '1px solid lightgray', }}>
                                                <Table stickyHeader size='small'>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell sx={{ backgroundColor: Colors.Background, width: '50%' }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Illness</Typography>
                                                            </TableCell>
                                                            <TableCell sx={{ backgroundColor: Colors.Background, width: '50%' }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Comments</Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            docNotes?.systemic_illness?.IllnessData?.length > 0 ? docNotes?.systemic_illness?.IllnessData?.map((item, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell style={{ fontWeight: 600 }}>
                                                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start" }}>
                                                                            <div style={{ fontSize: "0.9vw" }}>{item?.illness_name}</div>
                                                                            <div style={{ fontSize: "0.8vw" }}>{`${item?.year ? item.year : "0"}Y ${item?.month ? item?.month : "0"}M`}</div>
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {item?.treatment ? item?.treatment?.length > 15 ?
                                                                            <Tooltip placement='top' title={item?.treatment}>
                                                                                <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.treatment?.slice(0, 15) + '...'}</Typography>
                                                                            </Tooltip> :
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.treatment}</Typography> : '-'}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )) : <TableRow>
                                                                <TableCell />
                                                                <TableCell>No Records To Be Shown</TableCell>
                                                                <TableCell />
                                                            </TableRow>}
                                                    </TableBody>
                                                </Table>
                                            </Box>
                                            <Box component={'div'} sx={{ border: '1px solid lightgray', marginTop: "0.75vw" }}>
                                                <Typography fontWeight={'bold'} fontSize={'1vw'} margin={"0.5vw"}>Allergy</Typography>
                                                <Table stickyHeader size='small'>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell sx={{ backgroundColor: Colors.Background, width: '50%' }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Drug Allergy</Typography>
                                                            </TableCell>
                                                            <TableCell sx={{ backgroundColor: Colors.Background, width: '50%' }}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Comments</Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            docNotes?.systemic_illness?.AllergyData?.length > 0 ? docNotes?.systemic_illness?.AllergyData?.map((item, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell style={{ fontWeight: 600 }}>
                                                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start" }}>
                                                                            <div style={{ fontSize: "0.9vw" }}>{item?.name}</div>
                                                                            <div style={{ fontSize: "0.8vw" }}>{`${item?.no_of_years ? item.no_of_years : "0"}Y ${item?.no_of_months ? item?.no_of_months : "0"}M`}</div>
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {item?.comments ? item?.comments?.length > 15 ?
                                                                            <Tooltip placement='top' title={item?.comments}>
                                                                                <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.comments?.slice(0, 15) + '...'}</Typography>
                                                                            </Tooltip> :
                                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.comments}</Typography> : '-'}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )) : <TableRow>
                                                                <TableCell />
                                                                <TableCell>No Records To Be Shown</TableCell>
                                                                <TableCell />
                                                            </TableRow>}
                                                    </TableBody>
                                                </Table>
                                            </Box>
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'review_plan' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`review_plan_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`review_plan_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Review Plan</Typography>
                                        <Table stickyHeader size='small'>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                        <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Duration</Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                        <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Review Date & Time</Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                        <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Comments</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    docNotes?.review_plan?.ReviewData?.length > 0 ? docNotes?.review_plan?.ReviewData?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw" }}>{item?.duration ? `${item?.duration} ${item?.duration_type}` : '-'}</TableCell>
                                                            <TableCell>
                                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
                                                                    <div style={{ fontSize: "0.9vw" }}>{item?.review_date ? formatDate(item?.review_date) : "-"}</div>
                                                                    <div style={{ fontSize: "0.9vw" }}>{item?.appointment_time ? item?.appointment_time : "-"}</div>
                                                                </div>
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.comments ? item?.comments?.length > 15 ?
                                                                    <Tooltip placement='top' title={item?.comments}>
                                                                        <Typography fontSize={'0.9vw'}>{item?.comments?.slice(0, 15) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'}>{item?.comments}</Typography> : '-'}
                                                            </TableCell>
                                                        </TableRow>
                                                    )) : <TableRow>
                                                        <TableCell />
                                                        <TableCell align='center'>No Records To Be Shown</TableCell>
                                                        <TableCell />
                                                    </TableRow>}
                                            </TableBody>
                                        </Table>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'investigations' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`investigations_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`investigations_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Investigations</Typography>
                                        <Table stickyHeader size='small'>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                        <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Test</Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ backgroundColor: Colors.Background }}>
                                                        <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Status</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    (docNotes?.investigations?.Testdata?.length > 0 ? docNotes?.investigations?.Testdata?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell>
                                                                <Box component={'div'} display={'flex'} alignItems={'center'}>
                                                                    {item?.display_label ?
                                                                        item?.display_label?.length > 15 ?
                                                                            <Tooltip placement='top' title={item?.display_label}>
                                                                                <Typography fontSize={'0.8vw'} fontWeight={600} mr={'0.5vw'}>{item?.display_label?.slice(0, 15) + '...'}</Typography>
                                                                            </Tooltip> :
                                                                            <Typography fontSize={'0.8vw'} fontWeight={600} mr={'0.5vw'}>{item?.display_label}</Typography> : '-'
                                                                    }
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Typography fontSize={'0.8vw'} fontWeight={600} mr={'0.5vw'}>{item?.status ? item?.status : item?.is_transmitted ? "In Progress" : 'Await to transmit'}</Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    )) : <TableRow>
                                                        <TableCell align='right'>No Records To Be Shown</TableCell>
                                                        <TableCell />
                                                    </TableRow>
                                                    )}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'schirmer_test' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`schirmer_test_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`schirmer_test_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Schirmer Test</Typography>
                                        <Box component={'div'} sx={{ backgroundColor: Colors.white }} pt={'0.5vw'}>
                                            <Box component={'div'} sx={{ display: "flex", flexDirection: "row", justifyContent: "space-around", pb: "1vw" }}>
                                                {/* "Right Eye" : 1
                                                    "Right Eye" : 8 */}
                                                <TextField
                                                    disabled
                                                    label={("Right Eye")}
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position="end" className='eMed_nur_inputAdor'>{"mm"}</InputAdornment>,
                                                    }}
                                                    sx={{ width: "10vw" }}
                                                    size='small'
                                                    className={'eMed_nur_txtBox'}
                                                    autoComplete='off'
                                                    value={docNotes?.schirmer_test?.right_eye}
                                                    readOnly

                                                />
                                                <TextField
                                                    label={("Left Eye")}
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position="end" className='eMed_nur_inputAdor'>{"mm"}</InputAdornment>,
                                                    }}
                                                    sx={{ width: "10vw" }}
                                                    size='small'
                                                    className={'eMed_nur_txtBox'}
                                                    autoComplete='off'
                                                    value={docNotes?.schirmer_test?.left_eye}
                                                    readOnly
                                                />
                                            </Box>
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'vitals' && item.is_active) {
                            let bpsColor = docNotes?.vitals?.bp_s <= 120 ? "green" : "red"
                            let bpdColor = docNotes?.vitals?.bp_d <= 80 ? "green" : "red"
                            let tempColor = ((docNotes?.vitals?.tempUnit === 'F' && (docNotes?.vitals?.temp >= 97 && docNotes?.vitals?.temp <= 99)) || (docNotes?.vitals?.tempUnit === 'C' && (docNotes?.vitals?.temp >= 36.1 && docNotes?.vitals?.temp <= 37.2))) ? 'green' : 'red'
                            let spo2Color = (docNotes?.vitals?.spo2 >= 95 && docNotes?.vitals?.spo2 <= 100) ? "green" : "red"
                            let rateColor = (docNotes?.vitals?.pulserate >= 60 && docNotes?.vitals?.pulserate) ? 'green' : 'red'
                            let bloodColor = docNotes?.vitals?.bloodglucouse <= 200 ? 'green' : 'red'
                            let heartRateColor = docNotes?.vitals?.heartRate >= 60 && docNotes?.vitals?.heartRate <= 100 ? "green" : "red"
                            let respiratoryRateColor = docNotes?.vitals?.respiratoryRate >= 12 && docNotes?.vitals?.respiratoryRate <= 20 ? "green" : "red"
                            let capillaryColor = docNotes?.vitals?.capillaryRefillTime === "<2" ? "green" : docNotes?.vitals?.capillaryRefillTime === ">2-<3" ? "orange" : docNotes?.vitals?.capillaryRefillTime === ">3" ? "red" : ""
                            return (
                                <TriggerApiOnView id={`vitals_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`vitals_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Vitals</Typography>
                                        <AccordionDetails>
                                            <Box component={'div'} sx={{ backgroundColor: Colors.white }} p={'1vw'}>
                                                {docNotes?.vitals?.filteredRightField_data?.map((item, index) => {
                                                    const fields = docNotes?.vitals?.filteredRightField_data?.reduce((set, item) => {
                                                        if (item.is_active) {
                                                            set.add(item.field_name);
                                                        }
                                                        return set;
                                                    }, new Set());
                                                    const hasSys = fields.has('bpsystolic');
                                                    const hasDys = fields.has('bpdistolic');
                                                    return (
                                                        <Box>
                                                            {item?.field_name === 'height' ? <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Height</Typography>
                                                                {renderTextBox('height', docNotes?.vitals?.height, '12vw', 'cm')}
                                                            </Box> : null}
                                                            {item?.field_name === 'weight' ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Weight</Typography>
                                                                {renderTextBox('weight', docNotes?.vitals?.weight, '12vw', 'kg')}
                                                            </Box> : null}

                                                            {(docNotes?.vitals?.height && docNotes?.vitals?.weight) && (item?.field_name === 'bmi') ?
                                                                <Box component={'div'}
                                                                    sx={{ backgroundColor: docNotes?.vitals?.bmi < 18.5 ? '#FFCCCB' : ((docNotes?.vitals?.bmi >= 18.5) && (docNotes?.vitals?.bmi <= 25)) ? 'lightgreen' : ((docNotes?.vitals?.bmi > 25) && (docNotes?.vitals?.bmi <= 30)) ? '#FBB917' : '#FF6863' }}
                                                                    display={'flex'} borderRadius={'5px'} mt={'0.5vw'} p={'0vw 0.5vw'} justifyContent={'space-between'} alignItems={'center'} height={'2.5vw'}>
                                                                    <Typography fontWeight={600} fontSize={'0.9vw'}>BMI</Typography>
                                                                    <FormHelperText>
                                                                        <Typography fontWeight={600} fontSize={'0.8vw'}>{bmiHelperText(docNotes?.vitals?.bmi)}</Typography>
                                                                    </FormHelperText>
                                                                    <Typography fontWeight={600} fontSize={'0.9vw'}>{docNotes?.vitals?.bmi}</Typography>
                                                                </Box> : null}
                                                            {(docNotes?.vitals?.height && docNotes?.vitals?.weight) && (item?.field_name === 'bsa') ?
                                                                <Box component={'div'}
                                                                    sx={{ backgroundColor: ((docNotes?.vitals?.bsa >= 1.4) && (docNotes?.vitals?.bsa <= 2.4)) ? 'lightgreen' : ((docNotes?.vitals?.bsa < 1.4)) ? '#FBB917' : '#FF6863' }}
                                                                    display={'flex'} borderRadius={'5px'} mt={'0.5vw'} p={'0vw 0.5vw'} justifyContent={'space-between'} alignItems={'center'} height={'2.5vw'}>
                                                                    <Typography fontWeight={600} fontSize={'0.9vw'}>BSA</Typography>
                                                                    <FormHelperText>
                                                                        <Typography fontWeight={600} fontSize={'0.8vw'}>{bsaHelperText(docNotes?.vitals?.bsa)}</Typography>
                                                                    </FormHelperText>
                                                                    <Typography fontWeight={600} fontSize={'0.9vw'}>{docNotes?.vitals?.bsa}</Typography>
                                                                </Box> : null}
                                                            {(((hasDys && !hasSys) || (!hasDys && hasSys) || (hasDys && hasSys)) && item?.field_name === 'bpsystolic') ?
                                                                <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                    <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>{'BP | S > D'}</Typography>
                                                                    <Box component={'div'}>
                                                                        {hasSys ? <TextField
                                                                            size='small'
                                                                            sx={{ width: '4.5vw' }}
                                                                            value={docNotes?.vitals?.bp_s}
                                                                            placeholder='S'
                                                                            inputProps={{ style: { color: bpsColor, fontWeight: '600' } }}
                                                                        /> : null}
                                                                        {hasDys ? renderTextBox('bp_d', docNotes?.vitals?.bp_d, '8vw', 'mm/Hg', 'D', bpdColor) : null}
                                                                    </Box>
                                                                </Box> : null}
                                                            {item?.field_name === 'temp' ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Temp</Typography>
                                                                {renderTextBox('temp', docNotes?.vitals?.temp, '12vw', '', '', tempColor)}
                                                            </Box> : null}
                                                            {item.field_name === "spo2" ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>SpO2</Typography>
                                                                {renderTextBox('spo2', docNotes?.vitals?.spo2, '12vw', '%', '', spo2Color)}
                                                            </Box> : null}
                                                            {item.field_name === "pulse" ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Pulse Rate</Typography>
                                                                {renderTextBox('pulserate', docNotes?.vitals?.pulserate, '12vw', '/min', '', rateColor)}
                                                            </Box> : null}
                                                            {item.field_name === "blood_glucose" ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Blood Glucose</Typography>
                                                                {renderTextBox('blood_glucose', docNotes?.vitals?.bloodglucouse, '12vw', 'mg/DL', '', bloodColor)}
                                                            </Box> : null}
                                                            {
                                                                <>
                                                                    {item.field_name === "last_mensural" ? <Box component={'div'} display={'flex'} mt={'0.5dvw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                        <Typography fontWeight={600} fontSize={'0.9dvw'} color={Colors.SecondaryText}>Last Menstrual Period</Typography>
                                                                        {renderObgynDatePicker("obs_LastMenstrualPeriod")}
                                                                    </Box> : null}
                                                                    {item.field_name === "expected_date_of_delivery" ? <Box component={'div'} display={'flex'} mt={'0.5dvw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                        <FormControlLabel
                                                                            control={<Checkbox
                                                                                size='small' emed_tid="add_credit_bill"
                                                                                disabled={docNotes?.vitals?.obs_LastMenstrualPeriod === null && docNotes?.vitals?.obs_ExpectedDeliveryDate === null}
                                                                                checked={docNotes?.vitals?.DeliverydateCalac} />}
                                                                            label={
                                                                                <Typography fontWeight={600} fontSize="0.9dvw" color={Colors.SecondaryText}>
                                                                                    Expected date of delivery
                                                                                </Typography>
                                                                            }
                                                                        />
                                                                        {renderObgynDatePicker("obs_ExpectedDeliveryDate")}
                                                                    </Box> : null}
                                                                    {item.field_name === "gestational_age" ? <Box component={'div'} width={"100%"} display="flex" mt={'0.5dvw'} mb={'0.625dvw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                        <FormControlLabel
                                                                            control={<Checkbox
                                                                                size='small' emed_tid="add_credit_bill"
                                                                                disabled={docNotes?.vitals?.obs_LastMenstrualPeriod === null && docNotes?.vitals?.gestational_weeks === "" && docNotes?.vitals?.gestational_days === ""}
                                                                                checked={docNotes?.vitals?.GestationalCalculation} />}
                                                                            label={
                                                                                <Typography fontWeight={600} fontSize="0.9dvw" color={Colors.SecondaryText}>
                                                                                    Gestational Age
                                                                                </Typography>
                                                                            } />
                                                                        <Box component={'div'} display="flex" justifyContent={'space-between'} alignItems={'center'}>
                                                                            {renderTextBox("gestational_weeks", docNotes?.vitals?.gestational_weeks, "6dvw", "Weeks")}
                                                                            {renderTextBox("gestational_days", docNotes?.vitals?.gestational_days, "6dvw", "Days")}
                                                                        </Box>
                                                                    </Box> : null}
                                                                </>}
                                                            {(item.field_name === "head_circumference") ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Head Circumference</Typography>
                                                                {renderTextBox('headCircumference', docNotes?.vitals?.headCircumference, '12vw', 'CM')}
                                                            </Box> : null}
                                                            {(item.field_name === "waist_circumference") ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Waist Circumference</Typography>
                                                                {renderTextBox('waist_circumference', docNotes?.vitals?.waist_circumference, '12vw', 'CM')}
                                                            </Box> : null}
                                                            {/* {item.field_name === "vital_data_time" ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                        <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Vital Date and Time</Typography>
                                                        <Box component={'span'} sx={{ backgroundColor: Colors.ThemeLightColor, width: "12vw" }} className="eMed_Time_Style"  >
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DateTimePicker
                                                                inputFormat='DD-MM-YYYY & hh:mm A'
                                                                // value={docNotes?.vitals?.vitalDate}
                                                                name={"vitalDate"}
                                                                renderInput={(params) => <TextField size='small'
                                                                {...params}
                                                                variant='standard'
                                                                fullWidth
                                                                sx={{ marginTop: "1.5vw", width: "12vw" }}
                                                                />}
                                                            />
                                                            </LocalizationProvider>
                                                        </Box>
                                                        </Box> : null} */}
                                                            {item.field_name === "comments" && <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Comments</Typography>
                                                                {renderTextBox('comments', docNotes?.vitals?.comments, '12vw')}
                                                            </Box>}
                                                            {item.field_name === "nurse_name" && <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Nurse Name</Typography>
                                                                {renderTextBox('nurse_name', docNotes?.vitals?.nurseName, '12vw', '', '', "")}
                                                            </Box>}
                                                            {item?.field_name === 'oxygensource' ?
                                                                <Box>
                                                                    <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                        <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>{"Oxygen Source"}</Typography>
                                                                        {renderSelect("oxygen_source", oxygen_source_list,)}
                                                                    </Box>
                                                                    {
                                                                        docNotes?.vitals?.oxygen_source === "O2 (With Oxygen)" && <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>{"Oxygen Support"}</Typography>
                                                                             {renderTextBox('oxygen_support', docNotes?.vitals?.oxygen_support, '12vw', 'L/min', '', '')}
                                                                        </Box>
                                                                    }
                                                                </Box> : null}
                                                            {item?.field_name === 'heart_rate' ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Heart Rate</Typography>
                                                                {renderTextBox('heartRate', docNotes?.vitals?.heart_rate, '12vw', 'bpm', '', heartRateColor)}
                                                            </Box> : null}
                                                            {item?.field_name === 'respiratory_rate' ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Respiratory Rate</Typography>
                                                                {renderTextBox('respiratoryRate', docNotes?.vitals?.respiratory_rate, '12vw', 'breaths/min', '', respiratoryRateColor)}
                                                            </Box> : null}
                                                            {item?.field_name === 'respiratory_rate' ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'}>
                                                                <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText}>Capillary Refill Time</Typography>
                                                                {renderTextBox('respiratoryRate', docNotes?.vitals?.capillary_refill_time, '12vw', 'sec', '', capillaryColor)}
                                                            </Box> : null}
                                                        </Box>)
                                                })}
                                            </Box>
                                        </AccordionDetails>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'glass_prescription' && item.is_active && !props?.isNewOPT) {
                            return (
                                <TriggerApiOnView id={`glass_prescription_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`glass_prescription_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Glass Prescription</Typography>
                                        <Box sx={{ maxHeight: '53vw', overflow: 'auto' }} component={'div'}>
                                            {docNotes?.glass_prescription?.comparePopup ? null : <Box component={"div"} style={{ marginBottom: "0.75vw" }}>
                                                <div style={{ display: "flex", flexWrap: "wrap", paddingLeft: "0.5vw" }}>
                                                    <FormControl size='small' style={{ width: '32%', marginTop: "0.75vw" }}>
                                                        <InputLabel id="Dis_lay_Diet">{'Chart Used'}</InputLabel>
                                                        <Select
                                                            value={docNotes?.glass_prescription?.Chart ? docNotes?.glass_prescription?.Chart : ""}
                                                            label={'Chart Used'}
                                                            disabled
                                                        >
                                                            <MenuItem value={""}>{"Select Chart Used"}</MenuItem>
                                                            {DEFAULT_CHARTUSED_SR.map((item, index) => {
                                                                return <MenuItem key={index} value={item.value}>{(item.label ? item.label : "")}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                    <FormControl size='small' style={{ width: '32%', marginTop: "0.75vw", marginLeft: "0.75vw" }}>
                                                        <InputLabel id="Dis_lay_Diet">{'Muscle'}</InputLabel>
                                                        <Select
                                                            value={docNotes?.glass_prescription?.Muscle ? docNotes?.glass_prescription?.Muscle : ""}
                                                            label={'Muscle'}
                                                            disabled
                                                        >
                                                            <MenuItem value={""}>{"Select Muscle"}</MenuItem>
                                                            {DEFAULT_MUSCLES_SR.map((item, index) => {
                                                                return <MenuItem key={index} value={item.value}>{(item.label ? item.label : "")}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                    <FormControl size='small' style={{ width: '32%', marginTop: "0.75vw", marginLeft: "0.75vw" }}>
                                                        <InputLabel id="Dis_lay_Diet">{'Occupation'}</InputLabel>
                                                        <Select
                                                            value={docNotes?.glass_prescription?.Occupation ? docNotes?.glass_prescription?.Occupation : ""}
                                                            label={'Occupation'}
                                                            disabled
                                                        >
                                                            <MenuItem value={""}>{"Select Occupation"}</MenuItem>
                                                            {docNotes?.glass_prescription?.Occupation ? <MenuItem value={docNotes?.glass_prescription?.Occupation}>{(docNotes?.glass_prescription?.Occupation)}</MenuItem> : null}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </Box>}

                                            <Table stickyHeader size='small' style={{ height: "6vw" }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Eye</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>UCVA</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>SPH</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>CYL</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>AXIS</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>ADD</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>BCDVA</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>BCNVA</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>PRISM</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>VISION</TableCell>
                                                        <TableCell width={'12.5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>BASE</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {docNotes?.glass_prescription?.templateDataRight?.length > 0 ? docNotes?.glass_prescription?.templateDataRight?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Right</TableCell>
                                                            <TableCell>
                                                                {item?.DV_UCVA ? item?.DV_UCVA?.length > 15 ?
                                                                    <Tooltip placement='top' title={item?.DV_UCVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.DV_UCVA?.slice(0, 15) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.DV_UCVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.DV_SPH ? item?.DV_SPH : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.DV_CYL ? item?.DV_CYL : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.DV_AXIS ? item?.DV_AXIS : '-'}</TableCell>
                                                            <TableCell>
                                                                {item?.add ? item?.add?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.add}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.DV_BCDVA ? item?.DV_BCDVA?.length > 15 ?
                                                                    <Tooltip placement='top' title={item?.DV_BCDVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.DV_BCDVA?.slice(0, 15) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.DV_BCDVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.DV_BCNVA ? item?.DV_BCNVA : '-'}</TableCell>
                                                            <TableCell>
                                                                {item?.DV_PRISM ? item?.DV_PRISM?.length > 15 ?
                                                                    <Tooltip placement='top' title={item?.DV_PRISM}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.DV_PRISM?.slice(0, 15) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.DV_PRISM}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.DV_VISION ? item?.DV_VISION : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.DV_BASE ? item?.DV_BASE : '-'}</TableCell>

                                                        </TableRow>
                                                    )) : null}
                                                    {docNotes?.glass_prescription?.templateDataLeft?.length > 0 ? docNotes?.glass_prescription?.templateDataLeft?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>Left</TableCell>
                                                            <TableCell>
                                                                {item?.DV_UCVA ? item?.DV_UCVA?.length > 15 ?
                                                                    <Tooltip placement='top' title={item?.DV_UCVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.DV_UCVA?.slice(0, 15) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.DV_UCVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.DV_SPH ? item?.DV_SPH : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.DV_CYL ? item?.DV_CYL : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.DV_AXIS ? item?.DV_AXIS : '-'}</TableCell>
                                                            <TableCell>
                                                                {item?.add ? item?.add?.length > 10 ?
                                                                    <Tooltip placement='top' title={item?.add}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add?.slice(0, 10) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.add}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item?.DV_BCDVA ? item?.DV_BCDVA?.length > 15 ?
                                                                    <Tooltip placement='top' title={item?.DV_BCDVA}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.DV_BCDVA?.slice(0, 15) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.DV_BCDVA}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.DV_BCNVA ? item?.DV_BCNVA : '-'}</TableCell>
                                                            <TableCell>
                                                                {item?.DV_PRISM ? item?.DV_PRISM?.length > 15 ?
                                                                    <Tooltip placement='top' title={item?.DV_PRISM}>
                                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.DV_PRISM?.slice(0, 15) + '...'}</Typography>
                                                                    </Tooltip> :
                                                                    <Typography fontSize={'0.9vw'} fontWeight={600}>{item?.DV_PRISM}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.DV_VISION ? item?.DV_VISION : '-'}</TableCell>
                                                            <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item?.DV_BASE ? item?.DV_BASE : '-'}</TableCell>
                                                        </TableRow>
                                                    )) : null}
                                                </TableBody>
                                            </Table>
                                            {docNotes?.glass_prescription?.templateDataLeft?.length > 0 || docNotes?.glass_prescription?.templateDataRight?.length > 0 ? null :
                                                <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", height: "4vw", marginTop: "-2.5vw" }}>No Records To be Shown</div>
                                            }

                                            {docNotes?.lens?.comparePopup ? null : <Box>
                                                <Box sx={{ marginY: "0.65vw" }}>
                                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Lens Type</Typography>
                                                    {renderChip(LENS_TYPE_OPTIONS, docNotes?.glass_prescription?.LensType, "LensType")}
                                                </Box>
                                                <Box sx={{ marginY: "0.65vw" }}>
                                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Lens Coating</Typography>
                                                    {renderChip(LENS_COATING_OPTIONS, docNotes?.glass_prescription?.LensCoat, "LensCoat")}
                                                </Box>
                                            </Box>}
                                            {docNotes?.glass_prescription?.comparePopup ? null : <Box>
                                                <Box>
                                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Coating & Wearing Comments</Typography>
                                                    <TextField
                                                        multiline
                                                        rows={3}
                                                        sx={{ width: '97%', marginTop: "0.5vw", marginLeft: "0.5vw" }}
                                                        value={docNotes?.glass_prescription?.coatingCom}
                                                        disabled
                                                    />
                                                </Box>
                                            </Box>}
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'glass_prescription' && item.is_active && props?.isNewOPT) {
                            return (
                                <TriggerApiOnView id={`glass_prescription_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`glass_prescription_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Glass Prescription</Typography>
                                        <Box component={'div'} m={'0.5rem'}>
                                            <Box component={'div'} border={'1px solid lightgray'}>
                                                <Table size="small">
                                                    {renderTableHeaders()}
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell className='doc_notes_tbl_body_cell' sx={{ fontWeight: 600 }} align='center'>DV</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBoxGLASS('RE', 'DV_SPH', rightEye.DV_SPH, docNotes?.umaGlassPrescription?.SPHList, 'label', 'SPH')}</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBoxGLASS('RE', 'DV_CYL', rightEye.DV_CYL, docNotes?.umaGlassPrescription?.CYLList, 'label', 'CYL')}</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBoxGLASS('RE', 'DV_AXIS', rightEye.DV_AXIS, docNotes?.umaGlassPrescription?.AXISList, 'label', 'AXIS')}</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell' sx={{ borderRight: '1px solid lightgray !important' }}>{autocompleteTextBoxGLASS('RE', 'DV_BCDVA', rightEye.DV_BCDVA, docNotes?.umaGlassPrescription?.BCDVAList, 'label', 'VA',)}</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBoxGLASS('LE', 'DV_SPH', leftEye.DV_SPH, docNotes?.umaGlassPrescription?.SPHList, 'label', 'SPH')}</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBoxGLASS('LE', 'DV_CYL', leftEye.DV_CYL, docNotes?.umaGlassPrescription?.CYLList, 'label', 'CYL')}</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBoxGLASS('LE', 'DV_AXIS', leftEye.DV_AXIS, docNotes?.umaGlassPrescription?.AXISList, 'label', 'AXIS')}</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBoxGLASS('LE', 'DV_BCDVA', leftEye.DV_BCDVA, docNotes?.umaGlassPrescription?.BCDVAList, 'label', 'VA',)}</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell className='doc_notes_tbl_body_cell' sx={{ fontWeight: 600 }} align='center'>NV</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBoxGLASS('RE', 'NV_SPH', rightEye.NV_SPH, docNotes?.umaGlassPrescription?.NVLIST, 'label', 'SPH')}</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBoxGLASS('RE', 'NV_CYL', rightEye.NV_CYL, docNotes?.umaGlassPrescription?.CYLList, 'label', 'CYL')}</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBoxGLASS('RE', 'NV_AXIS', rightEye.NV_AXIS, docNotes?.umaGlassPrescription?.AXISList, 'label', 'AXIS')}</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell' sx={{ borderRight: '1px solid lightgray !important' }}>{autocompleteTextBoxGLASS('RE', 'NV_BCNVA', rightEye.NV_BCNVA, docNotes?.umaGlassPrescription?.BCNVAList, 'label', 'VA')}</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBoxGLASS('LE', 'NV_SPH', leftEye.NV_SPH, docNotes?.umaGlassPrescription?.NVLIST, 'label', 'SPH')}</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBoxGLASS('LE', 'NV_CYL', leftEye.NV_CYL, docNotes?.umaGlassPrescription?.CYLList, 'label', 'CYL')}</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBoxGLASS('LE', 'NV_AXIS', leftEye.NV_AXIS, docNotes?.umaGlassPrescription?.AXISList, 'label', 'AXIS')}</TableCell>
                                                            <TableCell className='doc_notes_tbl_body_cell'>{autocompleteTextBoxGLASS('LE', 'NV_BCNVA', leftEye.NV_BCNVA, docNotes?.umaGlassPrescription?.BCNVAList, 'label', 'VA')}</TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </Box>
                                            <>
                                                <Box component={'div'} display={'flex'} m={'1rem 0rem'}>
                                                    {autocompleteTextBox2('selectedEyeWear', docNotes?.glass_prescription.selectedEyeWear, docNotes?.glass_prescription?.eyeWearList, 'Recommended Eye Wear')}
                                                    {autocompleteTextBox2('selectedLensMaterial', docNotes?.glass_prescription.selectedLensMaterial, docNotes?.glass_prescription?.lensMaterialList, 'Lens Material')}
                                                    {autocompleteTextBox2('selectedLensEnhacement', docNotes?.glass_prescription.selectedLensEnhacement, docNotes?.glass_prescription?.lensEnhancementList, 'Lens Enhancement')}
                                                </Box>
                                                <Typography className='doc_notes_header_card_font'>Lens Type</Typography>
                                                <Box display="flex" flexDirection="row" gap={2}>
                                                    {docNotes?.glass_prescription?.lensTypeList?.map((item) => (
                                                        <FormControlLabel
                                                            key={item.value}
                                                            control={
                                                                <Checkbox
                                                                    disabled
                                                                    size='small'
                                                                    emed_tid={`ref_lens_type_${item.value}`}
                                                                    checked={docNotes?.glass_prescription?.selectedLensType?.length ? (docNotes?.glass_prescription?.selectedLensType[0]?.value === item?.value) : false}
                                                                />
                                                            }
                                                            label={item.label}
                                                        />
                                                    ))}
                                                </Box>
                                            </>
                                            <Box component={'div'} display={'flex'} alignItems={'center'} mt={'0.5rem'}>
                                                <TextField
                                                    disabled
                                                    size='small'
                                                    multiline
                                                    rows={3}
                                                    maxRows={5}
                                                    sx={{ width: '39.2dvw', mr: '0.5rem' }}
                                                    label='Comments'
                                                    value={docNotes?.glass_prescription.glassPrespComments}
                                                    inputProps={{ emed_tid: 'ref_cmts', maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
                                                />
                                            </Box>
                                        </Box>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'smile') {
                            return (
                                <TriggerApiOnView id={`smile_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`smile_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Smile</Typography>
                                        <AccordionDetails component={'div'} m={'0.5rem'}>
                                            {commonTblCopyCompare("Under Refraction", "enableCopyUnder", "enableCompareUnder", "openCompareUnderPopup", "underRefractionData", "prevUnderRefractionData")}
                                            {commonTblCopyCompare("Acceptances", "enableCopyAccep", "enableCompareAccep", "openCompareAccepPopup", "acceptanceData", "prevAcceptanceData")}
                                            {commonTblCopyCompare("Over Refraction", "enableCopyOver", "enableCompareOver", "openCompareOverPopup", "overRefractionData", "prevOverRefractionData")}

                                            <Box component={'div'}>
                                                <TextField
                                                    disabled
                                                    size='small'
                                                    multiline
                                                    fullWidth
                                                    maxRows={5}
                                                    value={docNotes?.smile?.smileComments}
                                                    placeholder='Comments'
                                                    inputProps={{ maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
                                                />
                                            </Box>
                                        </AccordionDetails>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'presyound') {
                            return (
                                <TriggerApiOnView id={`presyound_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`presyound_${id}`} marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Presyound</Typography>
                                        <AccordionDetails component={'div'} m={'0.5rem'}>
                                            <Box component={'div'} display={'flex'} alignItems={'center'} marginY={"0.5dvw"}>
                                                <Typography className='doc_notes_header_card_font'>Dominant : </Typography>
                                                <Typography className='doc_notes_header_card_font' sx={{ marginLeft: "1vw" }}>{docNotes?.presbyond.dominantEye === "RE" ? "Right Eye" : "Left Eye"}</Typography>
                                            </Box>
                                            {commonTblCopyComparePresbyond("Refraction", "refractionData")}
                                            {renderEyeData()}
                                            <Box component={'div'}>
                                                <TextField
                                                    disabled
                                                    size='small'
                                                    multiline
                                                    fullWidth
                                                    rows={6}
                                                    value={docNotes?.presbyond?.comments || ""}
                                                    placeholder='Comments'
                                                    inputProps={{ maxLength: COMMON_STYLE.CHAR_LIMIT_COMMENTS }}
                                                />
                                            </Box>
                                        </AccordionDetails>
                                    </Box>

                                </TriggerApiOnView>
                            )
                        }

                        else {
                            if (item.is_active) {
                                let name = item.custom_name
                                return (
                                    <Box marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>{name}</Typography>
                                        <TriggerApiOnView id={`${name}_${id}`} onEnterView={(id) => getNoteData(id, item.label)} isProgrammaticScroll={isProgrammaticScroll} >
                                            <Box id={`${name}_${id}`} marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                {Object.keys(docNotes[item.label] || {}).length > 0 ?
                                                    <Box display={'flex'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{name}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} ml={'1vw'}
                                                                dangerouslySetInnerHTML={{ __html: docNotes[item.label]?.comments || '-' }} />
                                                        </Box>
                                                    </Box> : null}
                                            </Box>
                                        </TriggerApiOnView>
                                    </Box>
                                )
                            }
                        }
                    }) :
                        <Box >
                            <Typography color={'#888888'}>{'Doctor Notes Not Available'}</Typography>
                        </Box>}
                </Box> :
                <Box>
                    <Box marginTop={'1vw'}>
                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Symptoms</Typography>
                        <TriggerApiOnView id={`symptomsIP_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                            <Box id={`symptomsIP_${id}`}>
                                {docNotes.IP_symptom.length > 0 ? docNotes.IP_symptom.map((item, i) => (
                                    <Box>
                                        <Typography fontSize={'.9vw'} fontWeight={'bold'} color={'#616161'}>{`Symptom ${i + 1}`}</Typography>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Doctor Name`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.doctor_name || '-'}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Symptom Name`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.symptoms_name || '-'}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Duration`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{`${item.duration} ${item.duration_type}`}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Description`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.description || '-'}</Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                )) : null}
                            </Box>
                        </TriggerApiOnView>
                    </Box>
                    <Box marginTop={'1vw'}>
                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Examination</Typography>
                        <TriggerApiOnView id={`examinationIP_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                            <Box id={`examinationIP_${id}`}>
                                {docNotes.IP_examination.length > 0 ? docNotes.IP_examination.map((item, i) => (
                                    <Box>
                                        <Typography fontSize={'.9vw'} fontWeight={'bold'} color={'#616161'}>{`Examination ${i + 1}`}</Typography>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Doctor Name`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.doctor_name || '-'}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Examination Name`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.exam_name || '-'}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Description`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.description || '-'}</Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                )) : null}
                            </Box>
                        </TriggerApiOnView>
                    </Box>
                    <Box marginTop={'1vw'}>
                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Provisional Diagnosis</Typography>
                        <TriggerApiOnView id={`proviDiagIP_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                            <Box id={`proviDiagIP_${id}`}>
                                {docNotes.IP_proviDig.length > 0 ? docNotes.IP_proviDig.map((item, i) => (
                                    <Box>
                                        <Typography >{item.notes || '-'}</Typography>
                                    </Box>
                                )) : null}
                            </Box>
                        </TriggerApiOnView>
                    </Box>
                    <Box marginTop={'1vw'}>
                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Diagnosis</Typography>
                        <TriggerApiOnView id={`diagnosisIP_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                            <Box id={`diagnosisIP_${id}`}>
                                {docNotes.IP_Dignosis.length > 0 ? docNotes.IP_Dignosis.map((item, o) => (
                                    <Box>
                                        <Typography fontSize={'.9vw'} fontWeight={'bold'} color={'#616161'}>{`Diagnosis ${o + 1}`}</Typography>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Doctor Name`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.doctor_name || '-'}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`ICD Code`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.icd_code || '-'}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Short Description`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.icd_short_desc || '-'}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Long Description`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.icd_desc || '-'}</Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                )) : null}
                            </Box>
                        </TriggerApiOnView>
                    </Box>
                    <Box marginTop={'1vw'}>
                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Discharge Notes</Typography>
                        <TriggerApiOnView id={`disNoteIP_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                            <Box id={`disNoteIP_${id}`}>
                                {docNotes.IP_notes.length > 0 ? docNotes.IP_notes.map((item, i) => (
                                    <Box>
                                        <Typography >{item.discharge_notes || '-'}</Typography>
                                    </Box>
                                )) : null}
                            </Box>
                        </TriggerApiOnView>
                    </Box>
                    <Box marginTop={'1vw'}>
                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Family Counselling</Typography>
                        <TriggerApiOnView id={`FamilyCounIP_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                            <Box id={`FamilyCounIP_${id}`}>
                                {docNotes.IP_notes.length > 0 ? docNotes.IP_notes.map((item, i) => (
                                    <Box>
                                        <Typography >{item.family_counselling || '-'}</Typography>
                                    </Box>
                                )) : null}
                            </Box>
                        </TriggerApiOnView>
                    </Box>
                    <Box marginTop={'1vw'}>
                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Medication & Instructions</Typography>
                        <TriggerApiOnView id={`medicationIP_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                            <Box id={`medicationIP_${id}`}>
                                {docNotes.IP_notes.length > 0 ? docNotes.IP_notes.map((item, i) => (
                                    <Box>
                                        <Typography >{item.instructions || '-'}</Typography>
                                    </Box>
                                )) : null}
                            </Box>
                        </TriggerApiOnView>
                    </Box>
                </Box>}
            {console.log("docNotes", docNotes)}
            {errorMsg && <ToastMsg
                severity={'error'}
                msg={errorMsgText}
                msgPop={msgClose.bind(this)}
            />}
        </Box>
    )
}
